var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkshop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612,28.37l-1.56.95a41.18,41.18,0,0,0-20.1,37.6,39.52,39.52,0,0,0,.79,5.82,43.3,43.3,0,0,0,26.81,30.84c7.87,2.93,16.94,3.75,23.19,9.32,8.13,7.24,8.39,19.53,8,30.34s0,23.11,8.12,30.32c5.11,4.52,12.38,5.95,19.23,5.59,18.14-1,34.35-13.6,42.41-29.67s8.78-35,5.23-52.58c-5-24.64-18.6-48.07-39.67-62.15S634.69,17.1,612,28.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39,27.85l1.45.72a36.68,36.68,0,0,1,20.49,31.94,35.16,35.16,0,0,1-.3,5.22A38.49,38.49,0,0,1,119.43,95c-6.77,3.15-14.76,4.52-19.91,9.9-6.7,7-6.06,17.92-5,27.48s1.68,20.5-5.06,27.46c-4.22,4.37-10.57,6.15-16.67,6.31-16.15.43-31.42-9.64-39.7-23.32s-10.26-30.41-8.35-46.26c2.67-22.2,13.11-43.95,30.8-57.92S98.43,19.46,119.39,27.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.23,
    cy: 47.88,
    r: 18.8,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.39,
    cy: 298.12,
    r: 18.8,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.23,391.36c0,.15-154.13.26-344.21.26s-344.25-.11-344.25-.26,154.09-.26,344.25-.26S716.23,391.22,716.23,391.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.39,386.51H173.31A23.11,23.11,0,0,1,150.2,363.4v-265a16.86,16.86,0,0,1,16.85-16.85H566.57A15.93,15.93,0,0,1,582.5,97.5V363.4A23.11,23.11,0,0,1,559.39,386.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.39,386.51s.31,0,.94-.06l1.16-.07c.46,0,1-.14,1.6-.22l1-.15,1.06-.28,1.16-.3,1.22-.45a23.57,23.57,0,0,0,2.69-1.2c.47-.24.92-.55,1.41-.83l.73-.45L573,382a22.82,22.82,0,0,0,9.05-14.69c.06-.43.13-.87.19-1.31s.06-.89.09-1.34c.06-.91.07-1.84.06-2.78V356q0-6.06,0-12.9c0-36.45,0-89.19-.07-154.36q0-24.43,0-51.15V110.36c0-2.31,0-4.63,0-7V99.89c0-1.17,0-2.35,0-3.51a15.78,15.78,0,0,0-6.73-11.81A15.42,15.42,0,0,0,569,82c-.29,0-.58-.1-.88-.13l-.9,0c-.59,0-1.2,0-1.81,0H453.87l-280.33,0h-4.66c-.77,0-1.56,0-2.32,0l-1.14.06-1.14.17a6.19,6.19,0,0,0-1.12.23c-.37.09-.74.18-1.11.29a18.38,18.38,0,0,0-2.12.85,15.72,15.72,0,0,0-3.8,2.5,16.31,16.31,0,0,0-3,3.43,17.93,17.93,0,0,0-1.95,4.1,17.48,17.48,0,0,0-.73,4.48c-.05,1.52,0,3.07,0,4.6v36.59q0,36.32,0,71.52c0,46.9,0,92.13,0,135.22v16.05c0,1.34,0,2.65.14,4l.29,1.94c.13.65.32,1.28.47,1.91a23.2,23.2,0,0,0,3.4,7,22.85,22.85,0,0,0,12.45,8.71c.62.14,1.23.35,1.87.44l1.89.29c1.28.07,2.55.15,3.84.13h67.07l106.6,0,154.35.07,42,0,10.91,0,3.72,0-3.72,0-10.91,0-42,.05-154.35.08-106.6,0-59.39,0h-7.68c-1.28,0-2.58-.05-3.88-.13L169,386.3c-.65-.09-1.27-.31-1.9-.45a23.33,23.33,0,0,1-16.15-16c-.16-.65-.36-1.29-.48-1.94l-.31-2c-.09-1.34-.16-2.68-.14-4V345.87c0-43.09,0-88.32,0-135.22V102.54c0-1.54,0-3.06,0-4.61a16.79,16.79,0,0,1,2.76-8.83,16.69,16.69,0,0,1,3.07-3.53A16.49,16.49,0,0,1,159.73,83a17.13,17.13,0,0,1,2.18-.88c.38-.11.76-.2,1.14-.3a6.51,6.51,0,0,1,1.15-.23c.39-.06.78-.13,1.17-.17l1.18-.06c.79-.06,1.55,0,2.33,0h4.66l280.33,0H565.36c.61,0,1.21,0,1.83,0l.92,0c.3,0,.6.08.9.12a16.06,16.06,0,0,1,13.62,14.79c.09,1.19,0,2.36.06,3.53v10.47q0,13.88,0,27.21,0,26.69,0,51.15c0,65.17-.06,117.91-.08,154.36q0,6.84,0,12.9c0,2,0,4,0,5.86,0,.94,0,1.87-.06,2.78,0,.46,0,.91-.09,1.36s-.14.88-.2,1.31A22.86,22.86,0,0,1,573.08,382l-.71.53-.73.45c-.49.29-.95.6-1.42.83a24.48,24.48,0,0,1-2.7,1.2l-1.23.44-1.17.3-1.06.27-1,.15c-.61.08-1.14.19-1.6.21l-1.16.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.05,391.15H154.46a22.34,22.34,0,0,1-22.34-22.34v-3.48a.86.86,0,0,1,.86-.86H599.62a.85.85,0,0,1,.86.86v7.38A18.44,18.44,0,0,1,582.05,391.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.05,391.15l.63,0a13.27,13.27,0,0,0,1.86-.16,18.43,18.43,0,0,0,11.05-5.84,18.56,18.56,0,0,0,3.47-5.48,19,19,0,0,0,1.34-7.44V368c0-.73,0-1.46,0-2.21,0-.38,0-.75-.24-1s-.64-.21-1-.21L495,364.64l-343.57.07H133a.64.64,0,0,0-.28.05.61.61,0,0,0-.36.41,5.13,5.13,0,0,0,0,.71v1.56c0,1,0,2.07.09,3.09a21.14,21.14,0,0,0,1.31,6,20,20,0,0,0,2.89,5.36,22.2,22.2,0,0,0,9.45,7.4,23.31,23.31,0,0,0,5.85,1.5c2,.19,4,.15,6.06.15h36l91.22,0,154.46.05,104.13.08,28.31,0,7.37,0,2.51,0s-.85,0-2.51,0l-7.37,0-28.31,0-104.13.08-154.46.05H158c-2,0-4.06,0-6.12-.16a23.41,23.41,0,0,1-6-1.53,22.65,22.65,0,0,1-9.65-7.56,24.88,24.88,0,0,1-1.69-2.62,25.14,25.14,0,0,1-1.27-2.86,21.91,21.91,0,0,1-1.34-6.1c-.06-1-.11-2.09-.09-3.12v-1.56a5,5,0,0,1,0-.83,1.07,1.07,0,0,1,.63-.73,1.15,1.15,0,0,1,.47-.09h18.4L495,364.3l104.13.07h.59a1,1,0,0,1,.56.25.9.9,0,0,1,.29.54,3.8,3.8,0,0,1,0,.58v6.43a19.26,19.26,0,0,1-1.38,7.49,18.55,18.55,0,0,1-3.51,5.51,17.53,17.53,0,0,1-4.21,3.41,17.3,17.3,0,0,1-6.92,2.39,13.15,13.15,0,0,1-1.87.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.92,
    y: 100.18,
    width: 395.65,
    height: 249.79,
    rx: 4.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.73 363.95 329.54 373.81 411.33 373.81 416.72 363.95 323.73 363.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.3,
    cy: 91.73,
    r: 3.24,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.92,124.65H237.5a0,0,0,0,1,0,0V350a0,0,0,0,1,0,0H173.19a5.27,5.27,0,0,1-5.27-5.27V124.65A0,0,0,0,1,167.92,124.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.46,134.82a4.73,4.73,0,0,1,1.16-.5l.24-1.15,1.94,0,.27,1.14a4.59,4.59,0,0,1,1.18.46l1-.64,1.39,1.34-.6,1a4.51,4.51,0,0,1,.5,1.15l1.15.24,0,1.94-1.14.28a4.67,4.67,0,0,1-.46,1.17l.64,1-1.34,1.4-1-.61a4.73,4.73,0,0,1-1.16.5l-.24,1.15-1.94,0-.28-1.13a4.7,4.7,0,0,1-1.17-.47l-1,.65-1.4-1.35.61-1a4.73,4.73,0,0,1-.5-1.16l-1.15-.24,0-1.94,1.13-.27a4.62,4.62,0,0,1,.47-1.18l-.65-1,1.35-1.39,1,.6Zm1,2.59a2.08,2.08,0,1,0,2.94-.06A2.07,2.07,0,0,0,199.49,137.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.54,189.12H184.2a3.12,3.12,0,0,1-3.11-3.12h0a3.12,3.12,0,0,1,3.11-3.12h30.34a3.12,3.12,0,0,1,3.11,3.12h0A3.12,3.12,0,0,1,214.54,189.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.54,173.24H184.2a3.12,3.12,0,0,1-3.11-3.12h0A3.12,3.12,0,0,1,184.2,167h30.34a3.12,3.12,0,0,1,3.11,3.12h0A3.12,3.12,0,0,1,214.54,173.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.54,158.71H184.2a3.12,3.12,0,0,1-3.11-3.12h0a3.12,3.12,0,0,1,3.11-3.12h30.34a3.12,3.12,0,0,1,3.11,3.12h0A3.12,3.12,0,0,1,214.54,158.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.08,140.52H267.34a3.12,3.12,0,0,1-3.11-3.12h0a3.12,3.12,0,0,1,3.11-3.12h28.74a3.12,3.12,0,0,1,3.11,3.12h0A3.12,3.12,0,0,1,296.08,140.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.08,156.84H267.34a3.12,3.12,0,0,1-3.11-3.12h0a3.12,3.12,0,0,1,3.11-3.12h28.74a3.12,3.12,0,0,1,3.11,3.12h0A3.12,3.12,0,0,1,296.08,156.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.08,173.7H267.34a3.12,3.12,0,0,1-3.11-3.12h0a3.11,3.11,0,0,1,3.11-3.11h28.74a3.11,3.11,0,0,1,3.11,3.11h0A3.12,3.12,0,0,1,296.08,173.7Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.82,206.3H267.34a3.11,3.11,0,0,1-3.11-3.11h0a3.11,3.11,0,0,1,3.11-3.12h16.48a3.12,3.12,0,0,1,3.12,3.12h0A3.12,3.12,0,0,1,283.82,206.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.82,223.2H267.34a3.11,3.11,0,0,1-3.11-3.11h0a3.11,3.11,0,0,1,3.11-3.12h16.48a3.12,3.12,0,0,1,3.12,3.12h0A3.12,3.12,0,0,1,283.82,223.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.78,223.2H302.57a3.11,3.11,0,0,1-3.11-3.11h0a3.11,3.11,0,0,1,3.11-3.12h30.21a3.11,3.11,0,0,1,3.12,3.12h0A3.11,3.11,0,0,1,332.78,223.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.7,238.23H285.49a3.12,3.12,0,0,1-3.12-3.12h0a3.12,3.12,0,0,1,3.12-3.11H315.7a3.11,3.11,0,0,1,3.11,3.11h0A3.11,3.11,0,0,1,315.7,238.23Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.51,
    y: 249.14,
    width: 25.01,
    height: 6.23,
    rx: 3.11,
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.4,289H302.63a3.12,3.12,0,0,1-3.12-3.12h0a3.12,3.12,0,0,1,3.12-3.12H321.4a3.12,3.12,0,0,1,3.12,3.12h0A3.12,3.12,0,0,1,321.4,289Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.4,324.45H302.63a3.12,3.12,0,0,1-3.12-3.12h0a3.12,3.12,0,0,1,3.12-3.11H321.4a3.12,3.12,0,0,1,3.12,3.11h0A3.12,3.12,0,0,1,321.4,324.45Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.55,324.45H334.64a3.12,3.12,0,0,1-3.12-3.12h0a3.12,3.12,0,0,1,3.12-3.11h32.91a3.11,3.11,0,0,1,3.11,3.11h0A3.11,3.11,0,0,1,367.55,324.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.58,324.45h-4.74a3.12,3.12,0,0,1-3.12-3.12h0a3.12,3.12,0,0,1,3.12-3.11h4.74a3.12,3.12,0,0,1,3.12,3.11h0A3.12,3.12,0,0,1,390.58,324.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.57,289H337.76a3.12,3.12,0,0,1-3.11-3.12h0a3.12,3.12,0,0,1,3.11-3.12h27.81a3.12,3.12,0,0,1,3.12,3.12h0A3.12,3.12,0,0,1,365.57,289Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.56,304.54h-88.8a3.11,3.11,0,0,1-3.11-3.11h0a3.12,3.12,0,0,1,3.11-3.12h88.8a3.12,3.12,0,0,1,3.12,3.12h0A3.12,3.12,0,0,1,426.56,304.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.82,289h-56.7a3.12,3.12,0,0,1-3.11-3.12h0a3.12,3.12,0,0,1,3.11-3.12h56.7a3.12,3.12,0,0,1,3.11,3.12h0A3.12,3.12,0,0,1,436.82,289Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.68,
    y: 249.14,
    width: 29.72,
    height: 6.23,
    rx: 3.11,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.66,
    y: 249.14,
    width: 12.07,
    height: 6.23,
    rx: 3.11,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.92,
    y: 249.14,
    width: 35.6,
    height: 6.23,
    rx: 3.11,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.16,238.23h-6.73a3.12,3.12,0,0,1-3.12-3.12h0a3.12,3.12,0,0,1,3.12-3.11h6.73a3.12,3.12,0,0,1,3.12,3.11h0A3.12,3.12,0,0,1,336.16,238.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.19,238.23H350.33a3.12,3.12,0,0,1-3.12-3.12h0a3.12,3.12,0,0,1,3.12-3.11h42.86a3.12,3.12,0,0,1,3.12,3.11h0A3.12,3.12,0,0,1,393.19,238.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.11,140.52H313.37a3.12,3.12,0,0,1-3.11-3.12h0a3.12,3.12,0,0,1,3.11-3.12h28.74a3.12,3.12,0,0,1,3.11,3.12h0A3.12,3.12,0,0,1,342.11,140.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.13,156.84H313.37a3.12,3.12,0,0,1-3.11-3.12h0a3.12,3.12,0,0,1,3.11-3.12h65.76a3.12,3.12,0,0,1,3.11,3.12h0A3.12,3.12,0,0,1,379.13,156.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.92,173.7H313.37a3.12,3.12,0,0,1-3.11-3.12h0a3.11,3.11,0,0,1,3.11-3.11H449.92a3.11,3.11,0,0,1,3.11,3.11h0A3.12,3.12,0,0,1,449.92,173.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.76,185.58H313.37a3.12,3.12,0,0,1-3.11-3.12h0a3.12,3.12,0,0,1,3.11-3.12h64.39a3.12,3.12,0,0,1,3.11,3.12h0A3.12,3.12,0,0,1,377.76,185.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.59,206.3H300.2a3.11,3.11,0,0,1-3.11-3.11h0a3.11,3.11,0,0,1,3.11-3.12h64.39a3.11,3.11,0,0,1,3.11,3.12h0A3.11,3.11,0,0,1,364.59,206.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.63,206.3H379.05a3.12,3.12,0,0,1-3.12-3.11h0a3.12,3.12,0,0,1,3.12-3.12h21.58a3.12,3.12,0,0,1,3.12,3.12h0A3.12,3.12,0,0,1,400.63,206.3Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.8,206.2H415a3.12,3.12,0,0,1-3.12-3.12h0A3.12,3.12,0,0,1,415,200H455.8a3.12,3.12,0,0,1,3.12,3.11h0A3.12,3.12,0,0,1,455.8,206.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.28,206.2H470.51a3.11,3.11,0,0,1-3.11-3.12h0a3.11,3.11,0,0,1,3.11-3.11h40.77a3.12,3.12,0,0,1,3.12,3.11h0A3.12,3.12,0,0,1,511.28,206.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.4,205.93H184.2a3.12,3.12,0,0,1-3.11-3.12h0a3.12,3.12,0,0,1,3.11-3.12h17.2a3.12,3.12,0,0,1,3.12,3.12h0A3.12,3.12,0,0,1,201.4,205.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.25,256.36H184.2a3.11,3.11,0,0,1-3.11-3.12h0a3.11,3.11,0,0,1,3.11-3.11h12.05a3.12,3.12,0,0,1,3.12,3.11h0A3.12,3.12,0,0,1,196.25,256.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.65,222.74H184.2a3.12,3.12,0,0,1-3.11-3.12h0a3.12,3.12,0,0,1,3.11-3.12h33.45a3.12,3.12,0,0,1,3.12,3.12h0A3.12,3.12,0,0,1,217.65,222.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.78,239.55H184.2a3.12,3.12,0,0,1-3.11-3.12h0a3.11,3.11,0,0,1,3.11-3.11h27.58a3.11,3.11,0,0,1,3.12,3.11h0A3.12,3.12,0,0,1,211.78,239.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,137.4a3.17,3.17,0,1,1-3.17-3.16A3.17,3.17,0,0,1,253.26,137.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,153.67a3.17,3.17,0,1,1-3.17-3.17A3.17,3.17,0,0,1,253.26,153.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,170.58a3.17,3.17,0,1,1-3.17-3.16A3.17,3.17,0,0,1,253.26,170.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,187.49a3.17,3.17,0,1,1-3.17-3.16A3.17,3.17,0,0,1,253.26,187.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,204.41a3.17,3.17,0,1,1-3.17-3.17A3.16,3.16,0,0,1,253.26,204.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,221.32a3.17,3.17,0,1,1-3.17-3.17A3.17,3.17,0,0,1,253.26,221.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,238.23a3.17,3.17,0,1,1-3.17-3.17A3.17,3.17,0,0,1,253.26,238.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,255.14a3.17,3.17,0,1,1-3.17-3.16A3.17,3.17,0,0,1,253.26,255.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,272.06a3.17,3.17,0,1,1-3.17-3.17A3.17,3.17,0,0,1,253.26,272.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,289a3.17,3.17,0,1,1-3.17-3.17A3.16,3.16,0,0,1,253.26,289Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,305.88a3.17,3.17,0,1,1-3.17-3.17A3.17,3.17,0,0,1,253.26,305.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26,322.79a3.17,3.17,0,1,1-3.17-3.17A3.17,3.17,0,0,1,253.26,322.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.24,99.94H558.41a5.34,5.34,0,0,1,5.34,5.34v19.36a0,0,0,0,1,0,0H167.68a0,0,0,0,1,0,0V105.5A5.56,5.56,0,0,1,173.24,99.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.76,350a6.43,6.43,0,0,0,.82-.08,4.93,4.93,0,0,0,2.22-1,4.77,4.77,0,0,0,1.72-3.53v-5.64c0-8.55,0-21.15,0-37.37,0-32.46,0-79.42-.07-137.44q0-21.76,0-45.54V105.83a12.09,12.09,0,0,0,0-1.49,4.63,4.63,0,0,0-1.28-2.58,4.56,4.56,0,0,0-2.57-1.32,9.33,9.33,0,0,0-1.51-.07H531.29l-108.93,0-249.6,0a4.63,4.63,0,0,0-3.48,1.58,4.48,4.48,0,0,0-.94,1.71,6.54,6.54,0,0,0-.18,2V163q0,32.34,0,63.69v61.46q0,15.06,0,29.8v25.52a8.82,8.82,0,0,0,.35,3.47,4.58,4.58,0,0,0,4,2.81c.58,0,1.19,0,1.78,0h48.89l52.88,0,94.91,0,137.43.08,37.37.05,9.72,0,3.31,0-3.31,0-9.72,0-37.37.05-137.43.07-94.91,0H174.25c-.6,0-1.18,0-1.8,0a5,5,0,0,1-1.81-.44,5.06,5.06,0,0,1-2.55-2.64,5,5,0,0,1-.39-1.83V317.94q0-14.73,0-29.8V226.68q0-31.32,0-63.69V105.7a6.74,6.74,0,0,1,.21-2.12,4.72,4.72,0,0,1,1-1.89,5.1,5.1,0,0,1,3.84-1.75l249.6,0,108.93,0H558a10.3,10.3,0,0,1,1.56.07,5,5,0,0,1,4.17,4.22,10.16,10.16,0,0,1,0,1.55v13.51q0,23.74,0,45.54c0,58-.06,105-.08,137.44,0,16.22,0,28.82,0,37.37,0,2.13,0,4,0,5.64a4.78,4.78,0,0,1-4,4.58,3.46,3.46,0,0,1-.62.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.84,
    cy: 112.71,
    r: 2.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.22,
    cy: 112.71,
    r: 2.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.59,
    cy: 112.71,
    r: 2.97,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241,162.88l-8.77,1.57a26.71,26.71,0,1,1,4.94-8.17h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,162.88s-.07-.14-.23-.42l-.71-1.27c-.65-1.13-1.6-2.8-2.82-4.95a.07.07,0,0,0-.09,0l0,0h0l.11.07a26.77,26.77,0,0,0,1.59-12.91,28.21,28.21,0,0,0-.84-4.06c-.21-.69-.48-1.37-.72-2.08a15.74,15.74,0,0,0-.9-2.08,26.36,26.36,0,0,0-5.74-7.88,26.87,26.87,0,0,0-20.71-7.19,27.31,27.31,0,0,0-11.73,4,23.63,23.63,0,0,0-2.63,1.86,13.73,13.73,0,0,0-1.22,1.07c-.39.37-.82.71-1.19,1.12a26.91,26.91,0,0,0-2.12,2.52c-.33.44-.66.88-1,1.34l-.85,1.43a26.81,26.81,0,0,0-1.34,24,26.72,26.72,0,0,0,25.27,16,29.49,29.49,0,0,0,4.39-.48,34.79,34.79,0,0,0,4-1.11,26.52,26.52,0,0,0,10.8-7.39l0,0,6.55-1.2,1.66-.32.55-.11-.58.1-1.69.28-6.51,1.12,0,0a26.54,26.54,0,0,1-10.78,7.28,36.43,36.43,0,0,1-3.94,1.09,28.85,28.85,0,0,1-4.35.45,26.5,26.5,0,0,1-25-15.9,26.43,26.43,0,0,1,1.33-23.74l.84-1.41c.31-.45.65-.89,1-1.33a24.91,24.91,0,0,1,2.09-2.48c.36-.41.79-.74,1.17-1.12a14.91,14.91,0,0,1,1.21-1,25.53,25.53,0,0,1,2.6-1.84,27.23,27.23,0,0,1,11.59-3.94,26.79,26.79,0,0,1,11.42,1.52,26.37,26.37,0,0,1,14.79,13.35,15.55,15.55,0,0,1,.89,2.07c.24.69.52,1.37.72,2.05a26.48,26.48,0,0,1-.65,16.86.06.06,0,0,0,0,.08.06.06,0,0,0,.07,0h-.1l2.87,4.88c.33.55.58,1,.75,1.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.09,145.07l-6.56,2.55,6.56,2.54v2.62L197.72,149v-2.73l9.37-3.79Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.13,137.31h2.74l-6.5,19.75h-2.73Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.59,146.26V149l-9.37,3.79v-2.62l6.55-2.54-6.55-2.55v-2.6Z",
    style: {
      fill: "#6492FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--file-2--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.67,113.24H447.86a6,6,0,0,1-6-6V41.08a6,6,0,0,1,6-6h30.32l23.47,24.19v48A6,6,0,0,1,495.67,113.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.87,89.53h59.77a0,0,0,0,1,0,0v17.8a5.91,5.91,0,0,1-5.91,5.91H447.79a5.91,5.91,0,0,1-5.91-5.91V89.53A0,0,0,0,1,441.87,89.53Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.18,35.1V53.72a5.57,5.57,0,0,0,5.56,5.57h17.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M478.42,55.36s-.23,4.51,4.91,6a5.61,5.61,0,0,0,.59.13c2.34.42,17.73,3.16,17.73,2.8v-5H483.74S479.27,59.14,478.42,55.36Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M466.42,70l-7.17,2.63,7.17,2.61v2.69L456.17,74v-2.8l10.25-3.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.13,62h3L470,82.28h-3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.77,71.18V74l-10.26,3.9V75.19l7.18-2.61L477.51,70V67.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,98.35v8h-1.86v-3.29h-3.65v3.29h-1.86v-8h1.86v3.17h3.65V98.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.55,99.87H465V98.35h7v1.52h-2.57v6.51h-1.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.29,106.38v-4.82l-2.37,4h-.84l-2.35-3.87v4.71H473v-8h1.53l3,5,3-5H482l0,8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.94,98.35h1.85v6.52h4v1.51h-5.88Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--file-1--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.34,179.39H58.55a5.48,5.48,0,0,1-5.48-5.48V113.3a5.48,5.48,0,0,1,5.48-5.48H86.32L107.82,130v43.93A5.48,5.48,0,0,1,102.34,179.39Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.31,157.68h52.28a1.24,1.24,0,0,1,1.24,1.24v14a6.48,6.48,0,0,1-6.48,6.48H59.55a6.48,6.48,0,0,1-6.48-6.48v-14A1.24,1.24,0,0,1,54.31,157.68Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.32,107.82v17.06a5.1,5.1,0,0,0,5.1,5.09h16.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.55,126.37a5.66,5.66,0,0,0,4.49,5.5l.54.12c2.14.39,16.24,2.89,16.24,2.57V130H91.42S87.32,129.84,86.55,126.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.74,167.14a4.69,4.69,0,0,1,8.13-2.9l-1.27,1.17a2.72,2.72,0,0,0-2.14-1,2.73,2.73,0,0,0,0,5.45,2.69,2.69,0,0,0,2.14-1L76.87,170a4.68,4.68,0,0,1-8.13-2.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.45,170.56l.67-1.49a5,5,0,0,0,2.81.89c1.17,0,1.64-.39,1.64-.91,0-1.6-4.95-.5-4.95-3.66,0-1.45,1.17-2.66,3.59-2.66a5.68,5.68,0,0,1,3,.76l-.6,1.5a4.72,4.72,0,0,0-2.36-.67c-1.17,0-1.62.43-1.62,1,0,1.57,5,.49,5,3.61,0,1.43-1.18,2.64-3.61,2.64A6.1,6.1,0,0,1,77.45,170.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.21,170.56l.67-1.49a4.92,4.92,0,0,0,2.81.89c1.16,0,1.64-.39,1.64-.91,0-1.6-5-.5-5-3.66,0-1.45,1.17-2.66,3.59-2.66a5.68,5.68,0,0,1,3,.76l-.61,1.5a4.69,4.69,0,0,0-2.36-.67c-1.16,0-1.61.43-1.61,1,0,1.57,5,.49,5,3.61,0,1.43-1.18,2.64-3.62,2.64A6.07,6.07,0,0,1,85.21,170.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.52,139.58c.9.27,1.32.84,1.32,2.19v3.13a1.29,1.29,0,0,0,1.42,1.45h.36v2.38H73.48c-2.44,0-3.7-1.25-3.7-3.5v-3.54a.8.8,0,0,0-.86-.92h-.64v-2.38h.64a.8.8,0,0,0,.86-.92v-3.55c0-2.24,1.26-3.5,3.7-3.5h1.14v2.39h-.36a1.29,1.29,0,0,0-1.42,1.45v3.13C72.84,138.74,72.42,139.3,71.52,139.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.62,138.39v2.38H92a.8.8,0,0,0-.86.92v3.54c0,2.25-1.25,3.5-3.7,3.5H86.28v-2.38h.35a1.29,1.29,0,0,0,1.43-1.45v-3.13c0-1.35.41-1.92,1.31-2.19-.9-.28-1.31-.84-1.31-2.19v-3.13a1.29,1.29,0,0,0-1.43-1.45h-.35v-2.39h1.13c2.45,0,3.7,1.26,3.7,3.5v3.55a.8.8,0,0,0,.86.92Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.64,250.34H692.21c4.94,0,8.94-4.63,8.94-10.34V122.93c0-5.71-4-10.34-8.94-10.34H549.64c-4.94,0-8.94,4.63-8.94,10.34V240C540.7,245.71,544.7,250.34,549.64,250.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.7,112.59H701.15a0,0,0,0,1,0,0v15.53a8.59,8.59,0,0,1-8.59,8.59H548.44A7.74,7.74,0,0,1,540.7,129V112.59A0,0,0,0,1,540.7,112.59Z",
    transform: "translate(1241.85 249.3) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.16,124.94a2.59,2.59,0,1,0,2.59-2.57A2.58,2.58,0,0,0,566.16,124.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.34,124.94a2.6,2.6,0,1,0,2.59-2.57A2.58,2.58,0,0,0,558.34,124.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.52,124.94a2.6,2.6,0,1,0,2.6-2.57A2.58,2.58,0,0,0,550.52,124.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.64,250.34l-.35,0a5.84,5.84,0,0,1-1-.13,8.11,8.11,0,0,1-3.76-1.79,10.5,10.5,0,0,1-3.56-6.32,31.21,31.21,0,0,1-.17-4.92v-5.64c0-15.92,0-39,0-67.42,0-7.12,0-14.58,0-22.34q0-5.83,0-11.89v-6.11a14.72,14.72,0,0,1,.22-3,11.34,11.34,0,0,1,1-2.86,10,10,0,0,1,1.68-2.41,8.26,8.26,0,0,1,2.24-1.73,7.5,7.5,0,0,1,2.62-.87,21.2,21.2,0,0,1,2.77-.09h142c.29,0,.58,0,.86.06a7.08,7.08,0,0,1,1.68.45,7.82,7.82,0,0,1,2.89,2.09,9.29,9.29,0,0,1,1.81,3.33,9.62,9.62,0,0,1,.39,1.92,18.73,18.73,0,0,1,.06,2v47.22c0,20.49,0,40.24,0,59.07v7c0,1.16,0,2.32,0,3.47,0,.58,0,1.15,0,1.71l-.12.84a7.45,7.45,0,0,1-.17.82,10.23,10.23,0,0,1-3.24,5.44,8.29,8.29,0,0,1-2.54,1.52,8.58,8.58,0,0,1-2.82.49H669.63l-40.28,0-58.32.05-15.86,0H551l-1.4,0,1.4,0,4.13,0,15.86,0,58.32.05,40.28,0h22.45a8.22,8.22,0,0,0,5.52-2.06,10.56,10.56,0,0,0,3.34-5.6c.06-.28.14-.56.18-.85l.12-.86c0-.59.06-1.17,0-1.75V228.89c0-18.83,0-38.58,0-59.07V122.6a19.75,19.75,0,0,0-.06-2,10.44,10.44,0,0,0-.41-2,9.49,9.49,0,0,0-1.88-3.45,8.13,8.13,0,0,0-3-2.18,7.58,7.58,0,0,0-1.74-.46c-.3,0-.6,0-.9-.06h-142a24.05,24.05,0,0,0-2.81.09,8.22,8.22,0,0,0-2.69.9,8.76,8.76,0,0,0-2.3,1.79,9.64,9.64,0,0,0-1.72,2.48,11.08,11.08,0,0,0-1,2.94,14.82,14.82,0,0,0-.23,3.11v6.11q0,6.06,0,11.89c0,7.76,0,15.22,0,22.34,0,28.46,0,51.5,0,67.42v5.64a32.77,32.77,0,0,0,.19,4.94,10.56,10.56,0,0,0,3.61,6.36,8.18,8.18,0,0,0,3.8,1.77,5.43,5.43,0,0,0,1,.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.18,195.91a2.4,2.4,0,0,1,1.14-1.89c10.13-6.7,17.76-21.56,18.53-34.14,0-.71,0-1.44.07-2.17h0c.58-18,3.23-39.8,5.61-45.61,4.39-10.74,19.26-11.75,19.26-11.75,19.75-1.41,23.27,13.76,25.27,27.58,1.24,8.59,2.38,40.69,2.38,40.69h0A44.68,44.68,0,0,1,647,196.24c-3.64,1.37-6.72,1.92-8.17.74a49.68,49.68,0,0,1-20.78,12.61,25.83,25.83,0,0,1-9.85,1.31c-2.15-.2-4.42-.92-5.71-2.66a5,5,0,0,1,4.25-7.88C606,197.93,601.1,198.65,601.18,195.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.75,110.13l-13.35-5.38-1.23,1.18c-7.86,0-14.65,5.89-15.08,15.67-.3,7.07-.51,14.25.59,19.47,2.21,10.49,10.38,11.43,10.38,11.43v8.16h0a7.73,7.73,0,0,0,11.73,3.81l10.36-7.24.12-43.5A3.72,3.72,0,0,0,657.75,110.13Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.53,129.12a1.36,1.36,0,0,0,1.38,1.3,1.3,1.3,0,0,0,1.34-1.29,1.37,1.37,0,0,0-1.38-1.31A1.31,1.31,0,0,0,643.53,129.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.8,129.12a1.36,1.36,0,0,0,1.38,1.3,1.3,1.3,0,0,0,1.33-1.29,1.36,1.36,0,0,0-1.37-1.31A1.31,1.31,0,0,0,630.8,129.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.07,124.93c.18.17,1.17-.64,2.63-.71s2.57.61,2.71.42-.11-.39-.59-.71a3.79,3.79,0,0,0-2.19-.55,3.63,3.63,0,0,0-2.08.78C630.12,124.53,630,124.86,630.07,124.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.27,124.41c.19.14,1.1-.77,2.54-1s2.62.34,2.75.14-.16-.38-.67-.65a3.78,3.78,0,0,0-2.23-.33,3.59,3.59,0,0,0-2,1C643.28,124,643.18,124.34,643.27,124.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.21,135.71a10.35,10.35,0,0,0-2.4-.31c-.37,0-.73-.07-.8-.32a1.82,1.82,0,0,1,.19-1.12c.3-.92.62-1.88,1-2.89,1.33-4.12,2.27-7.5,2.1-7.55s-1.38,3.24-2.7,7.36c-.32,1-.63,2-.92,2.91a2.2,2.2,0,0,0-.12,1.47,1,1,0,0,0,.64.51,2.18,2.18,0,0,0,.64.06A8.89,8.89,0,0,0,639.21,135.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.06,152.5a22.77,22.77,0,0,0,13.81-3.79s-3.29,7.44-13.81,7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640,139.2a2.61,2.61,0,0,1,2.31-1.09,2.38,2.38,0,0,1,1.7.8,1.53,1.53,0,0,1,.2,1.74,1.77,1.77,0,0,1-1.89.58,5.94,5.94,0,0,1-1.92-1,1.91,1.91,0,0,1-.44-.41.5.5,0,0,1,0-.55",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.55,136.51c-.24,0-.16,1.58-1.46,2.77s-3,1.11-3,1.33.4.29,1.11.27a4,4,0,0,0,2.51-1,3.42,3.42,0,0,0,1.12-2.32C643.86,136.88,643.66,136.49,643.55,136.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.91,118.86c.2.37,1.61,0,3.34-.09s3.17.19,3.34-.19c.07-.19-.22-.52-.83-.82a5.69,5.69,0,0,0-2.57-.48,5.55,5.55,0,0,0-2.52.7C643.08,118.33,642.82,118.68,642.91,118.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.7,120.31c.27.32,1.26-.08,2.47-.15s2.25.11,2.46-.25c.1-.17-.08-.5-.54-.79a3.42,3.42,0,0,0-2-.44,3.46,3.46,0,0,0-1.94.76C629.7,119.81,629.58,120.15,629.7,120.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661,132.3s-7.48,2.32-11.71-16.13c-1.44-6.31-7.29-11.42-7.29-11.42l2.37-.72s14.74,4.16,15,4.34,3.72,7.63,3.72,7.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.16,132.14c0-.78.78-2.69,1.55-2.85,2.06-.43,5.82-.45,6.11,4.83.41,7.21-6.91,6.13-6.93,5.93S659.29,134.86,659.16,132.14Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.93,137.19s.13.08.35.17a1.29,1.29,0,0,0,.94,0,3.1,3.1,0,0,0,1.28-2.87,4.22,4.22,0,0,0-.45-1.78,1.47,1.47,0,0,0-1-.91.64.64,0,0,0-.72.39c-.09.21,0,.35-.07.36s-.16-.11-.12-.41a.75.75,0,0,1,.26-.47.9.9,0,0,1,.68-.22,1.76,1.76,0,0,1,1.38,1,4.52,4.52,0,0,1,.55,2c0,1.45-.64,2.85-1.66,3.21a1.35,1.35,0,0,1-1.16-.12C662,137.36,661.91,137.2,661.93,137.19Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.93,128.77s-.4,0-1.08-.22a6.63,6.63,0,0,1-2.57-1.49,9.65,9.65,0,0,1-1.34-1.57,12.27,12.27,0,0,1-1.09-2.11,47.67,47.67,0,0,1-1.55-5.24c-.51-1.88-1.06-3.66-1.66-5.24a28.61,28.61,0,0,0-1.88-4.07,19.24,19.24,0,0,0-1.65-2.53c-.21-.29-.4-.5-.52-.64a1.47,1.47,0,0,0-.19-.22,1.58,1.58,0,0,0,.16.24c.11.15.29.37.49.66a23.16,23.16,0,0,1,1.59,2.55,32.55,32.55,0,0,1,1.84,4.07c.59,1.58,1.13,3.35,1.64,5.23a43.75,43.75,0,0,0,1.57,5.26,12.21,12.21,0,0,0,1.12,2.13,9,9,0,0,0,1.38,1.58,6.38,6.38,0,0,0,2.64,1.46A4.28,4.28,0,0,0,655.93,128.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.78,159.53a1.5,1.5,0,0,0,.08-.35q.07-.37.18-1c.16-.93.38-2.25.65-3.92l-.17,0c0,.26-.08.55-.12.85v0q-.07.15-.15.33l.18.06a69.65,69.65,0,0,0,2.31-11.6,70.77,70.77,0,0,0,.44-7.51,34.34,34.34,0,0,0-.71-8.23,13.23,13.23,0,0,0-1.31-3.28,17.64,17.64,0,0,0-2-2.77c-1.46-1.7-3-3.15-4.48-4.6l-7.75-7.62-5.23-5.11-1.44-1.38-.38-.35c-.09-.08-.13-.12-.14-.11l.12.13.35.38,1.39,1.42,5.17,5.19,7.69,7.67c1.44,1.45,3,2.91,4.46,4.59a14.26,14.26,0,0,1,3.23,5.92,34.5,34.5,0,0,1,.71,8.15,70.11,70.11,0,0,1-.41,7.47,73.14,73.14,0,0,1-2.21,11.59l.18.07.15-.33h0v0c0-.3.07-.59.1-.85l-.17,0c-.24,1.67-.43,3-.57,3.92-.05.44-.1.78-.13,1S665.78,159.53,665.78,159.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "674.28 235.39 681.39 250.34 614.95 250.34 619.09 236.11 674.28 235.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.42,211.75l9.67-47.24-16.6-7.21-.33-3.83-23.42,2.72-.55,3.6-13.43,4.65L618.89,178c-2.18,7.35-4.93,15.41-2,23.8l1,2.79.8,34,16.12-2L675,236.5c-1.18-3.23-2.35-3.94-3.15-5.84C669.16,224.27,668.42,211.75,668.42,211.75Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.1,232.48l21.54-13.32,11.79-38c4.32-12,6.32-12.66,12.33-16.72l.5,17s-7.61,46.73-10.17,50.17-31.69,12-31.69,12Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.25,242.3s-7.87,2.73-9.75,3.2-7.55.27-7.55.27-8.35,3.6-8.91,3.23-1.28-.76-.83-1.27,6.6-4.16,6.6-4.16l-4.58.94s-6.12,3.26-6.67,3.19-1.42-.72-1.19-1.47l.22-.74a1.46,1.46,0,0,1,.17-1.94l.55-.38-.3-.52a2.25,2.25,0,0,1,.46-2.42c1.07-1.19,3.28-3.78,3.28-3.78l8.1-3.16,16.73-1.11",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,239.58a11.4,11.4,0,0,1-.78,1.06,5.92,5.92,0,0,1-3.08,1.68,13,13,0,0,1-5.31-.24,19,19,0,0,0-6.69-.59,14.45,14.45,0,0,1-1.66.34.88.88,0,0,1-1-.68c0-.36.52-.6,1-.83l1.4-.69,4.83-2.42,3.23-1.67a7.16,7.16,0,0,0,1.16-.67,7,7,0,0,0-1.25.5l-3.3,1.52L568,239.21l-1.41.67a7.7,7.7,0,0,0-.74.39,1.05,1.05,0,0,0-.52.88,1.38,1.38,0,0,0,1.49,1.19c.65,0,1.18-.27,1.74-.34,2.27-.38,4.5.19,6.52.55a12.89,12.89,0,0,0,5.47.12,5.83,5.83,0,0,0,3.14-1.9,3.68,3.68,0,0,0,.53-.85C584.27,239.7,584.31,239.59,584.29,239.58Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.83,237.51c-.05-.15-3.14.93-7.12,1.3-.5.05-1,.08-1.45.11h-.12l-.06.09a17.09,17.09,0,0,1-4.3,3.72,4.12,4.12,0,0,0,1.54-.65,11.13,11.13,0,0,0,3.15-2.76l-.18.09c.48,0,1,0,1.48-.1a25.92,25.92,0,0,0,5.08-1A7,7,0,0,0,567.83,237.51Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.76,242c-.1-.12-1.57.94-3.6,1.87s-3.79,1.37-3.75,1.52a12,12,0,0,0,7.35-3.39Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.52,214.62l-9-33.47c-.58-2.13-1.56-5.49-2.56-8.25a16.42,16.42,0,0,0-4.51-6.81,9.54,9.54,0,0,0-2.34-1.58l-9,27.23,7,22-35.41,18.63,6.78,13.8,41.92-16.48a12.59,12.59,0,0,0,5.82-4.45C696.92,222.84,698.17,220,696.52,214.62Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.57,241.71l10.08-4.65,19.69-1.51,2.75-.42,4.14,8.48s-5.74,3.79-8.44,4l-16.55-.49-8.65.88Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.36,217.94a4.8,4.8,0,0,1-.06-1c0-.67,0-1.64-.12-2.87-.13-2.45-.38-5.93-.78-10v0c-.48-2.47-1.21-5.17-1.64-8.08a23,23,0,0,1-.27-4.5,20.43,20.43,0,0,1,.72-4.14,37.88,37.88,0,0,1,2.4-6.66c.86-1.82,1.65-3.24,2.2-4.22a9.11,9.11,0,0,1,.91-1.49,11.46,11.46,0,0,1-.73,1.59c-.49,1-1.23,2.45-2,4.28a39.36,39.36,0,0,0-2.27,6.62,20.17,20.17,0,0,0-.68,4,23.74,23.74,0,0,0,.27,4.41c.43,2.86,1.14,5.56,1.6,8.06v0h0c.36,4.07.55,7.55.59,10,0,1.23,0,2.21,0,2.88A5.65,5.65,0,0,1,618.36,217.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.21,216.63a18.42,18.42,0,0,0-5.85-2.73,19.22,19.22,0,0,0-6.47-.11,4.88,4.88,0,0,1,1.87-.56,12.42,12.42,0,0,1,9,2.07A4.82,4.82,0,0,1,688.21,216.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.49,157.3a3.37,3.37,0,0,1-.89.41c-.58.23-1.43.53-2.49.87a53.84,53.84,0,0,1-8.5,2,45,45,0,0,1-4.8.39,29.08,29.08,0,0,1-3.93-.18c-.56,0-1.06-.14-1.5-.22a11.13,11.13,0,0,1-1.11-.23,3.08,3.08,0,0,1-.93-.29c0-.09,1.36.21,3.57.37a36.63,36.63,0,0,0,3.88.07c1.47-.06,3.07-.2,4.74-.43a70.89,70.89,0,0,0,8.47-1.8C660.15,157.64,661.46,157.23,661.49,157.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.51,246.07a1.23,1.23,0,0,1-.15-.24c-.1-.2-.22-.44-.38-.74l-1.4-2.83c-1.21-2.51-2.92-6.07-5-10.43l-.08-.17.17-.09,25.74-14.19,9.65-5.29-.12.3c-2.88-9.39-5.39-17.55-7.2-23.42-.86-2.89-1.56-5.2-2.05-6.85l-.53-1.84a4.08,4.08,0,0,1-.16-.65,3.15,3.15,0,0,1,.24.62c.16.46.36,1.06.61,1.82.53,1.63,1.28,3.94,2.2,6.8l7.38,23.37.06.19-.18.1-9.65,5.31-25.8,14.08.08-.26c2,4.39,3.7,8,4.87,10.51l1.31,2.87c.13.31.24.56.32.76A1.12,1.12,0,0,1,647.51,246.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.15,202.41l56.74.46c1.84,0,3.6.89,3.87,2.71l6.2,41.35h29.22a1.71,1.71,0,1,1,0,3.41H548.85l-6.38-43.65A3.72,3.72,0,0,1,546.15,202.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.15,202.41a2.86,2.86,0,0,0-.89.09,3.73,3.73,0,0,0-2.87,3.24,10.76,10.76,0,0,0,.21,2.34q.36,2.5.82,5.76c1.25,8.67,3.05,21.16,5.26,36.52l0,.15h.15l90.55.05h2.44a2.32,2.32,0,0,0,1.29-.24,1.93,1.93,0,0,0,0-3.38,2.29,2.29,0,0,0-1.28-.24H613l.22.19c-2.23-14.81-4.31-28.63-6.18-41a3.21,3.21,0,0,0-1-2.16,4.22,4.22,0,0,0-2.17-1,19.78,19.78,0,0,0-2.29-.08h-2.23l-8.54-.06-15.18-.1-21.61-.11h-7.78s.17,0,.51,0l1.49,0,5.78.08,21.61.24,15.18.15,8.54.08,2.23,0a18.15,18.15,0,0,1,2.23.09,3.79,3.79,0,0,1,2,.87,2.8,2.8,0,0,1,.92,1.94l6.12,41,0,.19h29.07a1.92,1.92,0,0,1,1.06.18,1.48,1.48,0,0,1,.67,1.8,1.47,1.47,0,0,1-.67.78,1.92,1.92,0,0,1-1.06.19H639.4l-90.55,0,.17.15c-2.27-15.35-4.12-27.84-5.41-36.5q-.48-3.24-.86-5.75a10.23,10.23,0,0,1-.23-2.3,3.68,3.68,0,0,1,.65-1.77,3.72,3.72,0,0,1,2.1-1.44C545.84,202.41,546.15,202.44,546.15,202.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.48,225.85a3.56,3.56,0,1,1-3.55-3.55A3.55,3.55,0,0,1,580.48,225.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.66,250c-.08,0-1.88-10.51-4-23.51s-3.82-23.55-3.74-23.57,1.88,10.52,4,23.52S610.74,249.94,610.66,250Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M565.48,449.45l-10.59,30.76-38-14c1.56-3.55,23.89-3.57,23.89-3.57l6.52-19.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.16,465.31a1.65,1.65,0,0,1,.42,2.16,1.59,1.59,0,0,1-2.14.44,1.74,1.74,0,0,1-.43-2.3,1.64,1.64,0,0,1,2.27-.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.89,480.21l1.22-3.19-37-12.09s-2,.12-2.2,1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.27,462.2c-.06.19.83.61,1.52,1.54s.89,1.9,1.09,1.89.32-1.19-.54-2.3S540.29,462,540.27,462.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.68,462.37c-.11.17.57.78.91,1.8s.22,1.91.41,2,.69-.95.24-2.2S535.75,462.2,535.68,462.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.65,466.3c.16.11.76-.72.66-1.92s-.82-1.91-1-1.79.2.87.27,1.85S531.48,466.22,531.65,466.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.26,457.85c0,.19,1,.25,2,.71s1.71,1.09,1.87,1-.39-1.08-1.6-1.6S542.22,457.67,542.26,457.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.82,453.67a3.71,3.71,0,0,0,1.91.7,9.53,9.53,0,0,0,2.21.12,8.94,8.94,0,0,0,1.31-.18,2.22,2.22,0,0,0,.74-.23.87.87,0,0,0,.45-1,1.11,1.11,0,0,0-.66-.72,2.47,2.47,0,0,0-.75-.16,6.89,6.89,0,0,0-3.51.47c-1.18.49-1.74,1.07-1.69,1.13s.71-.33,1.85-.67a7.92,7.92,0,0,1,2.05-.33,8.52,8.52,0,0,1,1.22.06c.44.05.78.17.82.39s0,.11-.12.2a2.47,2.47,0,0,1-.54.17,10.92,10.92,0,0,1-3.32.22A15.94,15.94,0,0,0,544.82,453.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545,454c0,.05.67-.48,1.18-1.65a6.85,6.85,0,0,0,.51-2.18,6.72,6.72,0,0,0-.06-1.33,1.69,1.69,0,0,0-.86-1.41.94.94,0,0,0-1,.24,2.61,2.61,0,0,0-.45.62,4.46,4.46,0,0,0-.48,1.28,4.71,4.71,0,0,0,.09,2.27c.38,1.25,1.07,1.76,1.11,1.7a16.75,16.75,0,0,1-.64-1.82,4.61,4.61,0,0,1,.06-2,4.31,4.31,0,0,1,.44-1.08c.21-.39.48-.65.62-.56a1.14,1.14,0,0,1,.43.87,6.28,6.28,0,0,1,.09,1.21,7.06,7.06,0,0,1-.33,2C545.33,453.34,544.88,454,545,454Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.06,369.38c-1.49.86-78.43,4.63-80.16,7.46-2.48,4.07-29.66,78.47-29.66,78.47l28,8.79,28.92-63.83,68.79-2.06s11-3.92,11.23-16.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.81,428.6l-6,25.43-37.91-11.1c1.28-3.56,23-5.09,23-5.09l3.48-13.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.11,439.63a1.61,1.61,0,0,1,.55,2.08,1.55,1.55,0,0,1-2,.57,1.71,1.71,0,0,1-.58-2.21,1.62,1.62,0,0,1,2.21-.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.79,454l1-3.19-36.87-9.28s-1.9.25-2,1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.35,437.47c-.05.19.85.54,1.59,1.4s1,1.79,1.18,1.76.23-1.17-.68-2.2S539.36,437.29,539.35,437.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.89,438c-.09.17.62.72,1,1.68s.34,1.85.53,1.9.61-1,.09-2.16S535,437.78,534.89,438Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.24,442.05c.16.09.68-.76.51-1.92s-.93-1.81-1-1.67.25.83.38,1.78S531.06,442,531.24,442.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541,433.1c0,.19,1,.18,2,.56s1.74.95,1.89.82-.45-1-1.67-1.45S540.94,432.93,541,433.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.21,428.87a3.8,3.8,0,0,0,1.9.54,9.13,9.13,0,0,0,3.43-.29,2.49,2.49,0,0,0,.7-.27.84.84,0,0,0,.37-1,1.05,1.05,0,0,0-.68-.67,2.65,2.65,0,0,0-.74-.11,7.82,7.82,0,0,0-1.3.06,7.26,7.26,0,0,0-2.09.64c-1.12.56-1.62,1.16-1.57,1.22s.67-.37,1.76-.78a7.32,7.32,0,0,1,2-.46,6.71,6.71,0,0,1,1.19,0c.43,0,.77.11.82.32s0,.11-.1.2a2,2,0,0,1-.52.2,11,11,0,0,1-1.17.28,10.24,10.24,0,0,1-2,.17A11.29,11.29,0,0,0,543.21,428.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.37,429.2c.06.05.62-.51,1-1.69a6.16,6.16,0,0,0,.35-2.15,6.44,6.44,0,0,0-.14-1.29,1.66,1.66,0,0,0-.93-1.32.93.93,0,0,0-1,.3,2.68,2.68,0,0,0-.4.64A4.45,4.45,0,0,0,542,425a4.64,4.64,0,0,0,.24,2.2c.45,1.2,1.16,1.64,1.19,1.58a16,16,0,0,1-.74-1.73,4.65,4.65,0,0,1-.08-2,4,4,0,0,1,.36-1.08c.18-.39.42-.67.56-.58s.42.44.48.81a6.12,6.12,0,0,1,.17,1.17,7.22,7.22,0,0,1-.18,2C543.68,428.51,543.28,429.14,543.37,429.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.25,436.73,538.83,430l21.38-67.5c4.88-13.64,18.51-13.14,26.43-12L644.12,356l4,14.08-64,8.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M563.25,436.73c-1.52-.4-2.84-.79-4.36-1.19-.29.75-.3,1.6-.59,2.35l-.36,1.59c1.22.42,2.77.79,4,1.1a4.73,4.73,0,0,0,3.89-.74c1.06-.85,1.46-2.45,1.79-3.78l3.9-15.73c2.22-9,7.43-19,7.66-28.24C574.65,406.58,567,422,563.25,436.73Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M647.84,246.61a2.53,2.53,0,0,1,.94-1.51,6.39,6.39,0,0,1,4-1,17.15,17.15,0,0,0,1.64-5.31,3.46,3.46,0,0,1-1.89-.54,2.22,2.22,0,0,1-.31-.1c-1.34-.61-1.47-2.62-.63-3.83a7.7,7.7,0,0,1,3.68-2.36,12.84,12.84,0,0,0-2.85,1c-1,.3-2.33,0-2.44-1a2.21,2.21,0,0,1,.15-.91l.57-1.79a2,2,0,0,1,.79-1.24,4.31,4.31,0,0,1,1-.25c1.13-.31,1.72-1.68,2.85-2a5.19,5.19,0,0,1,2.52.38c.85.2,2,0,2.22-.79a8,8,0,0,1-2.88-2.44,2.76,2.76,0,0,1,.27-3.48,4.09,4.09,0,0,1,2.85-.58c1.11,0,2.48.3,2.78,1.37a2.87,2.87,0,0,1,3.53,2.26l2.85-.29c-.79-.86-1.93-1.38-2.61-2.32s-.56-2.65.58-2.9c.42-.09.87.05,1.27-.11s.53-.37.83-.39a1.12,1.12,0,0,1,.62.25l6,3.92c-.54-1.26-1.08-2.52-1.63-3.78s-.89-2.77.16-3.49,2.48.31,2.69,1.52a2,2,0,0,1,2.38,1.8,2,2,0,0,1,2.33,3,5.72,5.72,0,0,1,2.87.85,1.73,1.73,0,0,1,2.79-1.19,2.94,2.94,0,0,1,.44-1.71,1,1,0,0,1,1.55-.18,2,2,0,0,1,3.27-2l1-1.2a2.65,2.65,0,0,1,2.56,1.33c.42.93-.28,2.27-1.29,2.17.71,0,.55,1.13.13,1.71L693.72,222a2.23,2.23,0,0,1,2.76-.24,1.72,1.72,0,0,1,2.5,0,1.4,1.4,0,0,1,2.51.42c.18-.46.82-.49,1.31-.44a3.23,3.23,0,0,1,2,.69c.51.5.5,1.54-.17,1.79.61-.34,1.4.33,1.41,1a2.48,2.48,0,0,1-1,1.77,5.85,5.85,0,0,0-1.43,1.51,2.89,2.89,0,0,1,2-.42,7.66,7.66,0,0,1,3.65.72c.21-.49.9-.51,1.42-.4a8.51,8.51,0,0,1,4.35,2.36c.55.56,1.05,1.41.67,2.1a2,2,0,0,1-.8.71L711,236a10.56,10.56,0,0,1,5.28,3.75c.78.45,1.76.5,2.46,1.05s.64,2-.25,2a1.64,1.64,0,0,1,.47,1.91,1.47,1.47,0,0,1-.6.66,2.41,2.41,0,0,1-.42.48,3,3,0,0,1-1,.54,2,2,0,0,1-1.73.8,8.31,8.31,0,0,1,1.84,2.18,3.43,3.43,0,0,1,0,3.55,1.74,1.74,0,0,1-.13.15,1.68,1.68,0,0,1-.74,1.07,1.52,1.52,0,0,1,.14.94,3.77,3.77,0,0,1,.84,6.61c-.89.63-2.53.52-2.62-.57a2.91,2.91,0,0,1-2.23,1.62,2.84,2.84,0,0,1-1.49,3.92,3,3,0,0,1-.95,5,2.32,2.32,0,0,1-4.39,1.53,4.85,4.85,0,0,1-1.74,2.17,1.7,1.7,0,0,1-2.4-.63,3.19,3.19,0,0,1-4.69,1.52,2.06,2.06,0,0,1-4.1.36l-5.32-.05a18.94,18.94,0,0,1-3.53-.25,9.42,9.42,0,0,1-4.05-1.88,3.35,3.35,0,0,0-1.23-.75,3.41,3.41,0,0,0-1.63.25,8.6,8.6,0,0,1-8.19-1.93,4.22,4.22,0,0,0-1.08-.86,3.77,3.77,0,0,0-1.57-.22,15.33,15.33,0,0,1-3.87-.56,4.12,4.12,0,0,1-2.73-1.79c-.51-1,.09-2.54,1.21-2.52a2.43,2.43,0,0,0-.6-2,1.44,1.44,0,0,0-2-.08,1,1,0,0,0,.47,1.7c-1.2.83-3.07-.33-3.1-1.8a2.88,2.88,0,0,1,2.89-2.69,6.5,6.5,0,0,1-.09-3.22,2.36,2.36,0,0,1-3.22.37,4.13,4.13,0,0,1-2.65,1.9,2.45,2.45,0,0,1-2.7-1.48,1.76,1.76,0,0,1,1.68-2.26,2.11,2.11,0,0,1,1.87-3.05,3.24,3.24,0,0,1,2-3.47,1.74,1.74,0,0,1-2.46-1c-.67,1.07-2.33.81-3.42.17A2.29,2.29,0,0,1,647.84,246.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.84,246.61a1.81,1.81,0,0,0-.07.44,1.89,1.89,0,0,0,.41,1.22,4.16,4.16,0,0,0,1.77,1.22,3.4,3.4,0,0,0,1.38.23,1.7,1.7,0,0,0,1.41-.74h-.12a1.8,1.8,0,0,0,2.56,1l-.07-.14a3.36,3.36,0,0,0-2.06,3.57l.09-.11a2,2,0,0,0-1.83,1,2.09,2.09,0,0,0-.13,2.21l.1-.16a1.79,1.79,0,0,0-1.79,1.34,2,2,0,0,0,.9,2.21,2.81,2.81,0,0,0,2.57.24,4.52,4.52,0,0,0,2.08-1.77l-.18,0a2.51,2.51,0,0,0,3.41-.38l-.24-.12a6.82,6.82,0,0,0,.08,3.29l.13-.18a3.25,3.25,0,0,0-2,.74,2.72,2.72,0,0,0-1,1.92,2.25,2.25,0,0,0,1,2,2,2,0,0,0,2.28.12l.34-.24-.41,0a.86.86,0,0,1-.59-1,.93.93,0,0,1,1-.74,1.45,1.45,0,0,1,1.22.74,2.53,2.53,0,0,1,.27,1.54l.16-.15a1.39,1.39,0,0,0-1.06.5,2,2,0,0,0-.47,1.05,2,2,0,0,0,.14,1.16,2.67,2.67,0,0,0,.72.91,5.45,5.45,0,0,0,2,1,15.07,15.07,0,0,0,2.24.46c1.5.32,3.24-.29,4.23,1.1a8.92,8.92,0,0,0,6.79,2.36,13,13,0,0,0,2.45-.53,1.46,1.46,0,0,1,1.09.12,8.7,8.7,0,0,1,1,.73A9.52,9.52,0,0,0,682,276a13.65,13.65,0,0,0,5.2.75l5.34,0-.2-.17a2.37,2.37,0,0,0,2.34,1.93,2.34,2.34,0,0,0,2.17-2.32l-.33.17a3.4,3.4,0,0,0,5-1.62h-.4a1.55,1.55,0,0,0,1.14.95,2.18,2.18,0,0,0,1.5-.17,4.93,4.93,0,0,0,1.89-2.3l-.39,0a2.53,2.53,0,1,0,4.79-1.66l-.13.28a3,3,0,0,0,1.93-2.31,3.07,3.07,0,0,0-.91-3l-.07.38a3.05,3.05,0,0,0,1.61-4.23l-.16.32a3.14,3.14,0,0,0,2.4-1.74l-.42-.08a1.08,1.08,0,0,0,.35.73,1.46,1.46,0,0,0,.69.37,2.46,2.46,0,0,0,1.49-.13,3.79,3.79,0,0,0,1.91-2.21,3.88,3.88,0,0,0-.16-3,4.09,4.09,0,0,0-2.21-2.06l.15.26a1.73,1.73,0,0,0-.16-1.09l-.09.29a2,2,0,0,0,.85-1.21l0,.1a3.39,3.39,0,0,0,.43-3.37,7.49,7.49,0,0,0-2.15-2.83l-.17.4a2.24,2.24,0,0,0,1.93-.89l-.11.08a2.83,2.83,0,0,0,1.58-1.11l-.07.06a1.71,1.71,0,0,0,.84-1.39,1.87,1.87,0,0,0-.69-1.55l-.14.41a.86.86,0,0,0,.72-.36,1.34,1.34,0,0,0,.23-.73,1.65,1.65,0,0,0-.57-1.35,16.49,16.49,0,0,0-2.47-1.07l.07.06a10.8,10.8,0,0,0-5.4-3.82l0,.41,1.77-1.1,1.34-.83a9.6,9.6,0,0,0,1.35-.9,1.37,1.37,0,0,0,.43-.81,1.76,1.76,0,0,0-.14-.89,3.84,3.84,0,0,0-1-1.31,8.68,8.68,0,0,0-2.7-1.7,9,9,0,0,0-1.53-.46,2.26,2.26,0,0,0-.86,0,1,1,0,0,0-.77.56l.32-.1a6.51,6.51,0,0,0-2.93-.73c-.49,0-1,0-1.48,0a2.46,2.46,0,0,0-1.51.48l.35.28c.43-.86,1.49-1.31,2.11-2.27a1.69,1.69,0,0,0,.2-1.7,1.44,1.44,0,0,0-.63-.64,1,1,0,0,0-1,0l.19.41a1,1,0,0,0,.61-.65,1.5,1.5,0,0,0,0-.84,1.47,1.47,0,0,0-.42-.72,2.2,2.2,0,0,0-.68-.42,6,6,0,0,0-1.47-.29,2.59,2.59,0,0,0-.78,0,.92.92,0,0,0-.7.55l.44.06a1.5,1.5,0,0,0-1.32-1.22,1.47,1.47,0,0,0-1.62.72l.37,0a2,2,0,0,0-2.84,0l.31,0a2.45,2.45,0,0,0-3,.26l.33.29,1.48-2.05a2.93,2.93,0,0,0,.61-1.19,1.39,1.39,0,0,0,0-.73.7.7,0,0,0-.23-.37.76.76,0,0,0-.44-.14v.44a1.51,1.51,0,0,0,1.43-.87,1.86,1.86,0,0,0,.06-1.66,2.89,2.89,0,0,0-2.74-1.41H694l-.06.08-1,1.2.31,0a2.24,2.24,0,0,0-3.62,2.19l.38-.18a1,1,0,0,0-1-.34,1.47,1.47,0,0,0-.88.54,3.28,3.28,0,0,0-.47,1.81l.37-.14a1.83,1.83,0,0,0-2-.27,1.78,1.78,0,0,0-1.15,1.62l.32-.19a5.9,5.9,0,0,0-3-.88l.16.33a2.19,2.19,0,0,0-2.58-3.34l.29.19a2.17,2.17,0,0,0-2.65-2l.26.16a2.39,2.39,0,0,0-.81-1.36,2,2,0,0,0-1.49-.54,1.57,1.57,0,0,0-1.27.94,2.73,2.73,0,0,0-.13,1.54,13,13,0,0,0,1,2.71q.55,1.31,1.11,2.58l.29-.24-3.72-2.42-1.82-1.19a4.76,4.76,0,0,0-1-.56.84.84,0,0,0-.65.1c-.18.1-.32.2-.45.26a2.7,2.7,0,0,1-1,.08,1.38,1.38,0,0,0-1.05.51,2.31,2.31,0,0,0-.22,2.17,4.06,4.06,0,0,0,1.38,1.62,12.2,12.2,0,0,1,1.54,1.26l.11-.3-2.85.29.19.15a3,3,0,0,0-3.75-2.39l.21.11a2,2,0,0,0-1.45-1.26,6.89,6.89,0,0,0-1.84-.24,5.39,5.39,0,0,0-1.82.2,2.22,2.22,0,0,0-1.36,1.22,3.3,3.3,0,0,0,.59,3.35,9.77,9.77,0,0,0,2.62,2l-.07-.18a1.17,1.17,0,0,1-1,.73,2.83,2.83,0,0,1-1.35-.12,9.94,9.94,0,0,0-1.38-.34,2.16,2.16,0,0,0-1.41.27c-.83.51-1.31,1.32-2.06,1.68-.35.19-.79.14-1.24.32a1.64,1.64,0,0,0-.84,1c-.26.81-.51,1.59-.75,2.36a1.46,1.46,0,0,0,.09,1.24,1.63,1.63,0,0,0,1,.67,2.62,2.62,0,0,0,1.18,0,5.25,5.25,0,0,0,1.07-.4,5.6,5.6,0,0,1,2-.69l0-.22a14,14,0,0,0-2.34,1.12,4.36,4.36,0,0,0-1.64,1.75,3.3,3.3,0,0,0-.16,2.2,2,2,0,0,0,1.42,1.41h0a3.41,3.41,0,0,0,1.93.55l-.08-.1a16.78,16.78,0,0,1-1.61,5.3l0,0a9.86,9.86,0,0,0-2.67.32,3.75,3.75,0,0,0-1.62.95,2.5,2.5,0,0,0-.57.94,1.2,1.2,0,0,0-.08.35,2.66,2.66,0,0,1,.69-1.25,3.83,3.83,0,0,1,1.6-.9,10.18,10.18,0,0,1,2.65-.3h0v0a16.57,16.57,0,0,0,1.67-5.32v-.1h-.09a3.27,3.27,0,0,1-1.84-.54h0a1.79,1.79,0,0,1-1.29-1.29,3,3,0,0,1,.16-2.06,4.18,4.18,0,0,1,1.58-1.66,13.22,13.22,0,0,1,2.3-1.09l.66-.26-.71.05a5.55,5.55,0,0,0-2,.7,4.8,4.8,0,0,1-1,.37,2.28,2.28,0,0,1-1.07,0,1.34,1.34,0,0,1-.87-.56,1.18,1.18,0,0,1-.06-1c.24-.76.49-1.54.75-2.33a1.36,1.36,0,0,1,.69-.88,9.88,9.88,0,0,0,1.26-.33c.85-.41,1.34-1.23,2.08-1.67s1.68-.16,2.57.11a3.2,3.2,0,0,0,1.48.12,1.45,1.45,0,0,0,1.23-.93l0-.11-.1-.06a9.41,9.41,0,0,1-2.54-2,3,3,0,0,1-.54-3,1.94,1.94,0,0,1,1.18-1A5,5,0,0,1,660,219a6.77,6.77,0,0,1,1.75.23,1.62,1.62,0,0,1,1.22,1l0,.17.17-.05a2.72,2.72,0,0,1,3.31,2.12l0,.17.17,0,2.85-.28.36,0-.25-.26a12.83,12.83,0,0,0-1.57-1.31,3.58,3.58,0,0,1-1.26-1.46,1.94,1.94,0,0,1,.16-1.8,1,1,0,0,1,.78-.37,3,3,0,0,0,1.11-.11c.37-.19.61-.43.85-.34a4.53,4.53,0,0,1,.87.51l1.82,1.19,3.71,2.43.55.35-.26-.59q-.54-1.29-1.11-2.58a13.18,13.18,0,0,1-.95-2.63,2.36,2.36,0,0,1,.09-1.3,1.19,1.19,0,0,1,1-.71,2,2,0,0,1,1.86,1.57l0,.23.22-.07a1.75,1.75,0,0,1,2.11,1.61V217l.29-.12A1.77,1.77,0,0,1,682,219.6l-.24.33h.41a5.54,5.54,0,0,1,2.76.82l.34.22,0-.4a1.52,1.52,0,0,1,2.43-1l.34.34,0-.48a2.88,2.88,0,0,1,.39-1.58c.27-.39,1-.54,1.22-.19l.6.8-.22-1a1.9,1.9,0,0,1,.82-1.92,1.88,1.88,0,0,1,2.1.16l.17.14.14-.17,1-1.2-.16.08a2.43,2.43,0,0,1,2.33,1.16c.4.75-.2,2-1,1.9l0,.44c.14,0,.19,0,.24.2a1.11,1.11,0,0,1,0,.51,2.47,2.47,0,0,1-.54,1l-1.48,2.05.33.3a2,2,0,0,1,2.48-.23l.17.12.13-.15a1.5,1.5,0,0,1,2.16,0l.23.27.14-.32a1.19,1.19,0,0,1,2.09.35l.1,1.13.33-1.08c.09-.28.59-.35,1-.3a5.22,5.22,0,0,1,1.34.27,1.24,1.24,0,0,1,.83.82.77.77,0,0,1-.34,1l.19.41c.31-.19.78.08,1,.46a1.27,1.27,0,0,1-.18,1.24c-.51.83-1.57,1.27-2.13,2.31l-.54,1,.88-.71c.67-.53,1.73-.36,2.68-.34a6,6,0,0,1,2.72.66l.24.14.09-.25c.12-.32.67-.37,1.12-.28a9.27,9.27,0,0,1,1.45.43,8.32,8.32,0,0,1,2.55,1.62,3.4,3.4,0,0,1,.9,1.15,1,1,0,0,1-.19,1.19,10.76,10.76,0,0,1-1.27.84l-1.34.83-1.77,1.1-.43.26.48.15a10.33,10.33,0,0,1,5.17,3.67l0,0,0,0c.85.48,1.8.53,2.42,1a1.18,1.18,0,0,1,.39,1c0,.37-.2.67-.49.66l-.72-.05.58.45a1.42,1.42,0,0,1,.51,1.17,1.24,1.24,0,0,1-.62,1l0,0,0,0a2.36,2.36,0,0,1-1.34.94l-.07,0,0,.06a1.83,1.83,0,0,1-1.53.71l-.69-.07.52.46a7,7,0,0,1,2,2.64,2.92,2.92,0,0,1-.34,2.92l0,0V253a1.46,1.46,0,0,1-.64.92l-.18.11.1.19a1.18,1.18,0,0,1,.11.79l0,.19.19.07a3.69,3.69,0,0,1,2,1.83,3.43,3.43,0,0,1,.13,2.63,3.35,3.35,0,0,1-1.65,1.95,2,2,0,0,1-1.21.1.82.82,0,0,1-.71-.7l0-.87-.37.8a2.74,2.74,0,0,1-2.06,1.5l-.32,0,.16.29a2.64,2.64,0,0,1-1.37,3.6l-.38.13.31.25a2.83,2.83,0,0,1-.88,4.59l-.21.06.08.21a2.11,2.11,0,0,1-4,1.39l-.15-.48-.24.45a4.57,4.57,0,0,1-1.7,2.11,1.48,1.48,0,0,1-2.05-.54l-.2-.6-.2.61a3,3,0,0,1-4.37,1.42l-.33-.25v.42a1.93,1.93,0,0,1-1.78,1.9,2,2,0,0,1-1.92-1.58l0-.17h-.18l-5.34,0a13.51,13.51,0,0,1-5.06-.72A9.94,9.94,0,0,1,680,274.4a8.5,8.5,0,0,0-1-.77,1.88,1.88,0,0,0-1.35-.15,12.65,12.65,0,0,1-2.4.53,8.58,8.58,0,0,1-6.52-2.25,4.84,4.84,0,0,0-.94-.77,2.74,2.74,0,0,0-1.2-.28,19.05,19.05,0,0,1-2.29-.13,16,16,0,0,1-2.19-.45,5.39,5.39,0,0,1-1.93-.92,1.91,1.91,0,0,1-.75-1.77,1.33,1.33,0,0,1,1.2-1.27h.15l0-.15a2.74,2.74,0,0,0-.32-1.73,1.75,1.75,0,0,0-1.48-.89,1.25,1.25,0,0,0-1.33,1,1.14,1.14,0,0,0,.86,1.35l-.06-.28a1.72,1.72,0,0,1-1.94-.11,2,2,0,0,1-.93-1.71,2.78,2.78,0,0,1,2.74-2.4h.18l0-.17a6.55,6.55,0,0,1-.09-3.16l.13-.57-.36.46a2.25,2.25,0,0,1-3,.35l-.11-.09-.08.12a4.27,4.27,0,0,1-2,1.69,2.59,2.59,0,0,1-2.35-.21,1.72,1.72,0,0,1-.82-1.95,1.56,1.56,0,0,1,1.55-1.2l.21,0-.11-.18a2,2,0,0,1,1.78-2.9h.11v-.11a3.2,3.2,0,0,1,1.93-3.39l-.07-.14a1.65,1.65,0,0,1-2.34-.9l0-.14-.08.12a1.56,1.56,0,0,1-1.3.7,3.37,3.37,0,0,1-1.34-.21,4.16,4.16,0,0,1-1.76-1.17,1.84,1.84,0,0,1-.42-1.18C647.81,246.76,647.85,246.61,647.84,246.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.68,285.49c.09-2.81.15-5,.13-5s-9.6-1.38-9.83-11c-.11-4.62.43-14.17,1-22.8a17.86,17.86,0,0,1,17.6-16.63h.93c10,.47,15.15,9.2,14.41,19.16l-1,36.45-5.68,13.87c-5.67,6.21-17.89-5.65-17.57-14.05Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.75,280.46a23.16,23.16,0,0,0,12.43-3.84s-2.86,7.34-12.43,6.59Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.43,255.23a1.38,1.38,0,0,0,1.34,1.36,1.32,1.32,0,0,0,1.4-1.25,1.37,1.37,0,0,0-1.34-1.36A1.31,1.31,0,0,0,665.43,255.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.05,250.64c.17.18,1.2-.6,2.67-.61s2.56.71,2.72.52-.1-.4-.58-.73a3.74,3.74,0,0,0-2.18-.65,3.58,3.58,0,0,0-2.12.72C665.11,250.24,665,250.56,665.05,250.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.5,255.93a1.37,1.37,0,0,0,1.34,1.37,1.31,1.31,0,0,0,1.39-1.25,1.38,1.38,0,0,0-1.33-1.37A1.31,1.31,0,0,0,678.5,255.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.48,251.07c.17.18,1.2-.6,2.67-.62s2.56.71,2.72.53-.1-.4-.58-.74a3.84,3.84,0,0,0-2.18-.64,3.65,3.65,0,0,0-2.12.71C679.54,250.67,679.39,251,679.48,251.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.33,262.44a10.17,10.17,0,0,0-2.4-.4c-.38,0-.73-.1-.8-.36a1.92,1.92,0,0,1,.24-1.12l1.08-2.87c1.49-4.1,2.57-7.46,2.41-7.52s-1.52,3.21-3,7.3c-.36,1-.71,2-1,2.9a2.13,2.13,0,0,0-.18,1.47.94.94,0,0,0,.62.55,2.66,2.66,0,0,0,.64.08A9.27,9.27,0,0,0,674.33,262.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.07,246.1c.15.4,1.62.19,3.35.38s3.13.65,3.35.29c.1-.17-.14-.55-.71-.93a5.9,5.9,0,0,0-5.11-.51C679.32,245.59,679,245.91,679.07,246.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.58,245.68c.26.34,1.28,0,2.5,0s2.25.25,2.49-.1c.1-.16-.06-.5-.5-.82a3.44,3.44,0,0,0-2-.57,3.4,3.4,0,0,0-2,.65C665.62,245.18,665.47,245.52,665.58,245.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.9,266.23a6.17,6.17,0,0,0,.73,1.61,2.06,2.06,0,0,0,1.44.93,1.87,1.87,0,0,0,1.62-.78,3,3,0,0,0,.53-1.78c0-.57-.22-1.26-.78-1.35a1.42,1.42,0,0,0-.7.12l-3,1",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674,268.73a4.31,4.31,0,0,0,1.59-.12,2.32,2.32,0,0,0,1.25-1,2.38,2.38,0,0,0,.13-1.93,2.22,2.22,0,0,0-.24-.46c-.11-.13-.09-.12-.22-.11l-.48.16-.5.18-1.72.58a6.13,6.13,0,0,1-1.64.41,5.05,5.05,0,0,1,1.51-.76c.47-.21,1.05-.44,1.68-.69l.49-.19c.18-.06.32-.13.56-.2a.7.7,0,0,1,.44,0,.84.84,0,0,1,.31.27,2.93,2.93,0,0,1,.31.58,2.78,2.78,0,0,1-.21,2.37,2.55,2.55,0,0,1-1.56,1.14,2.38,2.38,0,0,1-1.29,0C674.09,268.87,674,268.76,674,268.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.49,238.73a11.19,11.19,0,0,1,.21-1.43,4.31,4.31,0,0,1,1.28-1.8c1.83-1.79,3.76-3.65,6.06-4.24,1.41-.36,2.87-.23,4.28-.58a22.31,22.31,0,0,0,2.55-.93,21,21,0,0,1,10.86-.58,17.12,17.12,0,0,1,5.83,1.89,20.8,20.8,0,0,1,5.23,4.76,31.66,31.66,0,0,1,5.82,9.38,15.46,15.46,0,0,1,.84,8.85c-.69,2.95-2.78,5.6-5.33,6l-.89-1.21-1.42-1.8c.23.72,0,.67-.6,1a1.22,1.22,0,0,1-1.69-.63c-.51.58-1.52-.14-1.31-.94-.59.27-1.28-.56-1-1.26-.69.2-1-.91-1.28-1.65a11.31,11.31,0,0,0-.59-1.15,7.43,7.43,0,0,1-.75-4.08,7.27,7.27,0,0,1-.93-4c0-.89-.07-1.77-.1-2.66-.15-.21-.3-.43-.44-.65a1.44,1.44,0,0,1-1.06,1.29,3.13,3.13,0,0,1-1.6-.16l-1.54-.44-1,.21a4,4,0,0,1-.5,2.54,2.46,2.46,0,0,1-1,1.35.75.75,0,0,1-1-.88.81.81,0,0,1-1.25-.31,2.69,2.69,0,0,1-.23-1.65,7.06,7.06,0,0,1,1.58-3.71l-2.94,2.34a1.35,1.35,0,0,1-.7.36.73.73,0,0,1-.84.73,1.84,1.84,0,0,1-1-.77c-.61-.75-1.22-2-.56-2.74a.58.58,0,0,1-.19-.88l-3.3,2.1c.33-.15.63.36.53.75a1.63,1.63,0,0,1-.72.87,2.39,2.39,0,0,1,.23,1.5c.6-.46,1.36.54,1.12,1.32a1.75,1.75,0,0,1-1.74,1.15,1.22,1.22,0,0,1-1.31-1c-.69.09-1.27-.9-1-1.65-.52.29-.88-.63-.85-1.3a9.64,9.64,0,0,1,.78-3.41.18.18,0,0,1-.26,0,.19.19,0,0,1,0-.13l-2,3.84a10,10,0,0,0-1.24,3.47c0,.51-.17,1.2-.6,1.21a.57.57,0,0,1-.33-.11,6.44,6.44,0,0,1-2.53-3.48,4.68,4.68,0,0,1-.3-1.53A20.25,20.25,0,0,1,660.49,238.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.14,237.39a1.56,1.56,0,0,1-.33-.79,1,1,0,0,1,.34-.86,1.1,1.1,0,0,1,1.15-.2l.24.11-.08-.25a1.16,1.16,0,0,1,.42-1.28,1.14,1.14,0,0,1,1.46.18l.21-.17a.69.69,0,0,1-.07-.15.68.68,0,0,1,.14-.55.75.75,0,0,1,.51-.26,1.32,1.32,0,0,1,.59.07,1.47,1.47,0,0,0,.65.21c.28,0,.42-.23.58-.31a2,2,0,0,1,.48-.24,2.54,2.54,0,0,1,1-.14,2.63,2.63,0,0,1,1.35.45c.28.2.4.35.42.33a1.14,1.14,0,0,0-.36-.41,2.5,2.5,0,0,0-1.39-.56,2.6,2.6,0,0,0-1,.12,2.39,2.39,0,0,0-.54.25c-.18.11-.32.26-.47.26a1.76,1.76,0,0,1-.54-.19,1.42,1.42,0,0,0-.71-.1,1,1,0,0,0-.68.35.94.94,0,0,0-.2.78.8.8,0,0,0,.11.25l.21-.17a1.36,1.36,0,0,0-2.3,1.35l.15-.14a1.28,1.28,0,0,0-1.36.27,1.16,1.16,0,0,0-.35,1,1.2,1.2,0,0,0,.27.63C674.06,237.36,674.14,237.4,674.14,237.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.41,238.53a1.86,1.86,0,0,1-.44-.78,1.34,1.34,0,0,1,.15-1,1.37,1.37,0,0,1,1.1-.66h.19l-.12-.16a1.65,1.65,0,0,1-.32-1.48.86.86,0,0,1,.58-.55.7.7,0,0,1,.77.17l.68.87-.46-1a1.38,1.38,0,0,1,0-1.16,1.34,1.34,0,0,1,1.85-.54l.3.18-.1-.33c-.14-.47.37-1,.83-1a2.27,2.27,0,0,1,1.37.47l.24.16-.06-.28a1,1,0,0,1,.4-.92,1.83,1.83,0,0,1,.94-.32,4.59,4.59,0,0,1,1.69.18,8.12,8.12,0,0,1,1.38.63,1.86,1.86,0,0,0-.31-.25,4.33,4.33,0,0,0-1-.51,4.58,4.58,0,0,0-1.76-.25,1.88,1.88,0,0,0-1,.35,1.17,1.17,0,0,0-.5,1.13l.18-.12a2.49,2.49,0,0,0-1.52-.53,1.28,1.28,0,0,0-.81.4.93.93,0,0,0-.25.92l.19-.16a1.66,1.66,0,0,0-1-.2,1.54,1.54,0,0,0-1.18.86,1.66,1.66,0,0,0,0,1.38l.22-.14a.94.94,0,0,0-1-.24,1.13,1.13,0,0,0-.73.7,1.89,1.89,0,0,0,.39,1.69l.08-.17a1.53,1.53,0,0,0-1.23.79,1.38,1.38,0,0,0-.12,1.1,1.46,1.46,0,0,0,.35.61C667.33,238.5,667.41,238.54,667.41,238.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.11,238.54a1,1,0,0,1,.4-.69,1.28,1.28,0,0,1,.91-.24,3.67,3.67,0,0,1,1.23.4l.14.07v-.16a1.14,1.14,0,0,1,1-1,3.26,3.26,0,0,1,1.85.46l.8.38-.66-.59a.93.93,0,0,1,.19-1.34,2.13,2.13,0,0,1,1.68-.25l.08,0,.51.09-.41-.33a1,1,0,0,1,.25-1.58,1.51,1.51,0,0,1,1.68.31l.51.47-.31-.62a2.29,2.29,0,0,1,.2-2.32,2.14,2.14,0,0,1,1.65-.86,2.38,2.38,0,0,1,1.24.27c.26.14.38.25.39.24s0,0-.08-.1a1.32,1.32,0,0,0-.28-.21,2.38,2.38,0,0,0-1.27-.35,2.27,2.27,0,0,0-1.81.89,2.49,2.49,0,0,0-.26,2.55l.19-.14a1.77,1.77,0,0,0-2-.36,1.26,1.26,0,0,0-.65.91,1.11,1.11,0,0,0,.36,1.11l.11-.24h-.09a2.34,2.34,0,0,0-1.89.31,1.35,1.35,0,0,0-.47.83,1,1,0,0,0,.28.9l.14-.21a3.5,3.5,0,0,0-2-.45,1.32,1.32,0,0,0-1.17,1.26l.13-.09a3.6,3.6,0,0,0-1.3-.38,1.34,1.34,0,0,0-1,.31.94.94,0,0,0-.35.55C653.08,238.47,653.1,238.54,653.11,238.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.71,225.67s.1.08.34.15a4.45,4.45,0,0,0,1,.15,2.92,2.92,0,0,1,1.46.35.92.92,0,0,1,.46.69.68.68,0,0,1-.33.75l.17.14c.08-.33.52-.51.92-.7a4.56,4.56,0,0,1,1.29-.43,1.6,1.6,0,0,1,1.25.3,1.07,1.07,0,0,1,.46,1l-.07.32.27-.2a2.93,2.93,0,0,1,1.79-.56,3.32,3.32,0,0,1,1.47.34,4,4,0,0,1,1.07.83s0-.12-.2-.31a2.73,2.73,0,0,0-.8-.66,3.37,3.37,0,0,0-1.53-.41,3.13,3.13,0,0,0-2,.57l.19.13a1.33,1.33,0,0,0-.54-1.29,1.93,1.93,0,0,0-1.44-.36,4.52,4.52,0,0,0-1.37.46,5.07,5.07,0,0,0-.61.32,1,1,0,0,0-.45.57l-.06.24.23-.1a.9.9,0,0,0,.47-1,1.12,1.12,0,0,0-.58-.83,3.13,3.13,0,0,0-1.57-.33,5.19,5.19,0,0,1-1-.07A2.08,2.08,0,0,0,661.71,225.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.32,221.7a2.56,2.56,0,0,1,.69.16,1.72,1.72,0,0,1,.63.47,1.53,1.53,0,0,1,.34.93v.15l.14,0a.9.9,0,0,1,.93.63,2.67,2.67,0,0,1-.08,1.47l-.12.52.36-.4.06-.06a1.1,1.1,0,0,1,.94-.3,1.23,1.23,0,0,1,.84.45,2,2,0,0,1,.4,1.61,3.72,3.72,0,0,1-.4,1.13,1.94,1.94,0,0,0-.2.4,1.22,1.22,0,0,0,.29-.35,3.24,3.24,0,0,0,.49-1.14,2.19,2.19,0,0,0-.39-1.81,1.49,1.49,0,0,0-2.17-.18l-.07.08.23.12a2.83,2.83,0,0,0,.06-1.63,1.12,1.12,0,0,0-1.22-.76l.14.11a1.63,1.63,0,0,0-.43-1,1.85,1.85,0,0,0-.72-.48,1.57,1.57,0,0,0-.55-.08C675.38,221.67,675.32,221.69,675.32,221.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.24,230.77a.9.9,0,0,0,.36-.05,2.23,2.23,0,0,0,.85-.5,2.46,2.46,0,0,0,.72-1.28c.05-.28.06-.55.24-.71s.5-.27.72-.56a1.33,1.33,0,0,0-.19-1.82V226a4.31,4.31,0,0,0,1.27-1.48,1.67,1.67,0,0,0,.25-.71s-.13.25-.38.64a4.5,4.5,0,0,1-1.28,1.35l-.14.1.13.1a1.11,1.11,0,0,1,.13,1.47c-.15.21-.45.29-.7.53a1.47,1.47,0,0,0-.3.85,2.22,2.22,0,0,1-.61,1.19A3.41,3.41,0,0,1,686.24,230.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.46,233.4s.07,0,.22,0a4.31,4.31,0,0,0,.63,0,3.58,3.58,0,0,0,2.06-.95l-.17,0a2.35,2.35,0,0,0,2.5.93,1.47,1.47,0,0,0,.9-.59,2.61,2.61,0,0,0,.14-.37.5.5,0,0,1,.19-.24,1.74,1.74,0,0,1,.63-.22,1.83,1.83,0,0,0,.71-.22.76.76,0,0,0,.44-.62l-.18.1a2.34,2.34,0,0,0,1.62.18,2.47,2.47,0,0,0,1.12-.58,1.93,1.93,0,0,0,.5-.64c.08-.18.1-.27.09-.28a3.5,3.5,0,0,1-.68.81,2.36,2.36,0,0,1-1.07.49,2.19,2.19,0,0,1-1.47-.19l-.17-.09v.19a.51.51,0,0,1-.31.41,2,2,0,0,1-.63.19,1.73,1.73,0,0,0-.75.26.84.84,0,0,0-.28.34,2.79,2.79,0,0,1-.12.35,1.24,1.24,0,0,1-.74.46,2.12,2.12,0,0,1-2.24-.79l-.08-.11-.09.09a3.65,3.65,0,0,1-1.92,1C689.77,233.41,689.46,233.37,689.46,233.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.76,243.38s0,0,0-.09a1.68,1.68,0,0,0,.07-.27,2.86,2.86,0,0,0,0-1.07,6.7,6.7,0,0,0-.58-1.55,6.4,6.4,0,0,0-.52-.89,1.42,1.42,0,0,0-.44-.4.7.7,0,0,0-.65-.06l.16.13a1.78,1.78,0,0,0-2.75-1.79l.2.12a1.2,1.2,0,0,0-.41-1,1.16,1.16,0,0,0-1.12-.23,1.19,1.19,0,0,0-.56.35l.24.11a.77.77,0,0,0-.23-.65,1,1,0,0,0-.58-.3,2.31,2.31,0,0,0-1.16.19l.15.06a1.9,1.9,0,0,0-1.08-.9,2.65,2.65,0,0,0-1.3-.11,6.43,6.43,0,0,0-2.09.83l.12.13a.44.44,0,0,0,0-.47.83.83,0,0,0-.31-.28,1.39,1.39,0,0,0-.7-.17,4.06,4.06,0,0,0-1.08.23,3.79,3.79,0,0,0-.63.3.81.81,0,0,0-.2.15,8.57,8.57,0,0,1,.86-.35,4.19,4.19,0,0,1,1.06-.17,1.19,1.19,0,0,1,.61.16c.19.11.35.32.23.51l-.17.28.3-.15a6.6,6.6,0,0,1,2-.77,2.43,2.43,0,0,1,1.19.11,1.68,1.68,0,0,1,.93.79l0,.1.11,0a2.24,2.24,0,0,1,1-.17c.31,0,.64.34.58.64l-.08.47.31-.36a1.05,1.05,0,0,1,.44-.27.91.91,0,0,1,.87.18,1,1,0,0,1,.32.81l0,.29.24-.16a1.55,1.55,0,0,1,1.76,0,1.58,1.58,0,0,1,.62,1.51l0,.21.2-.09c.29-.14.62.12.83.37a6.37,6.37,0,0,1,.51.85,6.47,6.47,0,0,1,.62,1.5A3.38,3.38,0,0,1,709.76,243.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.61,251.05l.14-.16a4.19,4.19,0,0,0,.36-.5,1.85,1.85,0,0,0,.3-1,1.49,1.49,0,0,0-.15-.63,1.08,1.08,0,0,0-.55-.5l0,.15a1.25,1.25,0,0,0-1.17-2l.11.2a1,1,0,0,0,.06-1.19,1.46,1.46,0,0,0-1.09-.62,4.5,4.5,0,0,1-.59-.06.48.48,0,0,1-.34-.35,2.1,2.1,0,0,0-.3-.6,1.11,1.11,0,0,0-.6-.4,6.49,6.49,0,0,0-1.41-.16,1.52,1.52,0,0,1-1.12-.43c-.12-.15-.2-.35-.32-.54a1.32,1.32,0,0,0-.51-.46,1.41,1.41,0,0,0-1.25,0l.14.18a1,1,0,0,0,0-1.24,1.45,1.45,0,0,0-1-.58,4.75,4.75,0,0,0-1.76.07,5.93,5.93,0,0,0-1.08.33,1.14,1.14,0,0,0-.35.18,11.19,11.19,0,0,1,1.45-.38,5.06,5.06,0,0,1,1.7,0,1.29,1.29,0,0,1,.82.51.84.84,0,0,1,0,1l-.32.4.46-.22a1.19,1.19,0,0,1,1,0,1.12,1.12,0,0,1,.4.38,5.25,5.25,0,0,0,.34.56,1.38,1.38,0,0,0,.6.41,2.79,2.79,0,0,0,.7.13,7.35,7.35,0,0,1,1.35.14.93.93,0,0,1,.47.31,2.17,2.17,0,0,1,.26.55.77.77,0,0,0,.52.5,5.5,5.5,0,0,0,.63.06,1.21,1.21,0,0,1,.91.5.76.76,0,0,1,0,.89l-.23.25.34-.05a1,1,0,0,1,1,1.66l-.08.11.12,0a1,1,0,0,1,.61,1,1.88,1.88,0,0,1-.24.91C707.77,250.8,707.58,251,707.61,251.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.44,265.51s.09,0,.26-.06a1.75,1.75,0,0,0,.65-.42,1.88,1.88,0,0,0,.54-1.09,2,2,0,0,0-.41-1.54v.15a3.73,3.73,0,0,0,.8-1.27,1.4,1.4,0,0,0,0-.86,1.11,1.11,0,0,0-.57-.71V260a1.56,1.56,0,0,0,.78-1.33,1.75,1.75,0,0,0-.2-.9,1.5,1.5,0,0,0-.64-.61.5.5,0,0,1-.34-.52,2.13,2.13,0,0,0-.11-.79,2.64,2.64,0,0,0-.9-1.15l-.94-.8a4.53,4.53,0,0,0-1.56-.91,2.41,2.41,0,0,0-.49-.08h-.17s.23,0,.62.17a5,5,0,0,1,1.48,1l.91.83a2.54,2.54,0,0,1,.82,1.06,2,2,0,0,1,.09.71.72.72,0,0,0,.1.46,1.15,1.15,0,0,0,.35.29,1.3,1.3,0,0,1,.71,1.26,1.27,1.27,0,0,1-.64,1.11l-.24.13.25.11a1.06,1.06,0,0,1,.43,1.26,3.32,3.32,0,0,1-.74,1.19l-.06.08.06.07a1.8,1.8,0,0,1,.41,1.36,1.82,1.82,0,0,1-.45,1A2.65,2.65,0,0,1,708.44,265.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.1,242a1.94,1.94,0,0,0,.81-.25,2.21,2.21,0,0,0,.77-.56,1.49,1.49,0,0,0,.36-1.13.89.89,0,0,0-.09-.29l-.07.18a1.27,1.27,0,0,0,.73-.83,1.17,1.17,0,0,0-.09-.88c-.26-.45-.6-.52-.6-.49s.26.17.43.57a1,1,0,0,1,0,.73,1,1,0,0,1-.6.65l-.12,0,.05.13a.79.79,0,0,1,.06.22,1.26,1.26,0,0,1-.28.94,2.53,2.53,0,0,1-.67.54C686.38,241.84,686.08,242,686.1,242Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.15,238.61a1.53,1.53,0,0,1-.11-1,1.1,1.1,0,0,1,.7-.78,1.21,1.21,0,0,1,1.26.3l.15.18.07-.23a2.15,2.15,0,0,1,.37-.76,1,1,0,0,1,.7-.41c.43,0,.88.41.73.75l.25.07a2,2,0,0,1,.84-1.26,2,2,0,0,1,1.18-.34,3,3,0,0,1,1.1.3.65.65,0,0,0-.25-.2,2,2,0,0,0-.84-.26,2.08,2.08,0,0,0-1.31.31,2.25,2.25,0,0,0-1,1.4l.25.08a.76.76,0,0,0-.2-.8,1,1,0,0,0-.78-.32,1.24,1.24,0,0,0-.9.52,2.42,2.42,0,0,0-.41.86l.22-.05a1.4,1.4,0,0,0-1.52-.34,1.26,1.26,0,0,0-.78.94,1.28,1.28,0,0,0,.09.8A.49.49,0,0,0,680.15,238.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.19,256.32c.16-.07,6.56-2,6.43,4.53s-6.69,5.06-6.69,4.88S695.19,256.32,695.19,256.32Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697,263.28s.11.09.3.18a1.1,1.1,0,0,0,.85,0,2.8,2.8,0,0,0,1.36-2.5,3.75,3.75,0,0,0-.28-1.64,1.33,1.33,0,0,0-.84-.9.58.58,0,0,0-.68.3c-.1.18-.06.31-.09.33s-.14-.12-.08-.39a.73.73,0,0,1,.26-.4.86.86,0,0,1,.64-.16,1.62,1.62,0,0,1,1.17,1A3.94,3.94,0,0,1,700,261a3,3,0,0,1-1.72,2.79,1.21,1.21,0,0,1-1-.19C697,263.44,697,263.3,697,263.28Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.76,366.68l-2.45-14.09.15,0,36.07-11.11s8.94-35.81,10.71-40.13c2.17-5.33,10-11.31,13-10.91,5.06.68,15.6-1.35,9.35,24.81-2.42,10.12-8.66,27.72-12.84,39.11a15.4,15.4,0,0,1-13.6,10.07Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696,283.26l-25.11,4.57c-.64.74-10.64,17.19-12.84,22s-9.65,30.9-9.65,30.9l-16.75,15.94,8.11,12.25a26.8,26.8,0,0,0,10.64,9.31c7.68,3.72,17.53,8.16,20.92,8.16a19.7,19.7,0,0,0,6.32-1.3l.05,0,0,0c.27-.52,24.69-52.62,26.2-68.52A54.84,54.84,0,0,0,696,283.26Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.44,305.53c1.93,8.37,12,43.44,12,43.44l39.14,13.61.71-3.15-37.11-13.79-11.26-41a1.8,1.8,0,0,0-2.11-1.27h0A1.79,1.79,0,0,0,578.44,305.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.44,305.53a1.24,1.24,0,0,1-.06-.22,1.81,1.81,0,0,1,0-.67,1.77,1.77,0,0,1,.58-.93,1.87,1.87,0,0,1,2.94.75c.21.68.4,1.4.63,2.19q.66,2.39,1.52,5.43c2.26,8.15,5.47,19.72,9.3,33.5l-.14-.15,37.12,13.76.21.08-.05.22c-.07.32-.15.66-.22,1-.17.71-.33,1.43-.48,2.13l-.07.29-.27-.1-39.13-13.64-.11,0,0-.11c-3.69-13-6.7-23.84-8.75-31.47-1-3.81-1.81-6.81-2.31-8.86-.25-1-.44-1.82-.55-2.35l-.13-.61q0-.21,0-.21a1.3,1.3,0,0,1,.06.2c0,.15.1.35.17.6.14.55.35,1.33.62,2.33.56,2.07,1.39,5,2.43,8.83,2.12,7.6,5.19,18.44,8.93,31.41l-.14-.15,39.15,13.58-.34.19c.16-.7.32-1.42.48-2.14.07-.34.15-.69.22-1l.17.31-37.1-13.82-.11,0,0-.12c-3.75-13.8-6.9-25.39-9.11-33.55l-1.47-5.44c-.21-.79-.41-1.52-.59-2.19a1.71,1.71,0,0,0-1.34-1.09,1.75,1.75,0,0,0-1.36.36,1.85,1.85,0,0,0-.58.87A2.23,2.23,0,0,0,578.44,305.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.69,354.27l-9.28-7.12-14.77,3.56s.21,1.3,2.11,1.93l4-.63-7.38,5.06a4.07,4.07,0,0,0,2.85,2.85,7.38,7.38,0,0,1,3.69,2.64l2.78,2.93a4.84,4.84,0,0,0,3.8,1.51l7.35-.43,6.87-.7-2-11.6Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.56,315.22c-2.42,10.12-8.66,27.72-12.84,39.11a15.4,15.4,0,0,1-13.6,10.07l-40.36,2.28-2.45-14.09.15,0,36.07-11.11s8.94-35.81,10.71-40.13",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.24,301.32s-.07.24-.23.71-.36,1.18-.64,2.1c-.53,1.85-1.28,4.57-2.2,8.07-1.85,7-4.42,17.06-7.47,29.29l0,.1-.1,0-36.06,11.15h0l-.14,0,.17-.25c.78,4.52,1.61,9.26,2.45,14.09l-.23-.18,2.88-.16,37.56-2.11A15.22,15.22,0,0,0,685,355.56c.54-1.15.93-2.35,1.37-3.51s.84-2.31,1.25-3.43q1.2-3.37,2.31-6.46c2.91-8.24,5.14-15,6.55-19.64.71-2.34,1.22-4.17,1.56-5.41.16-.61.29-1.08.38-1.41s.14-.48.14-.48a4.38,4.38,0,0,1-.1.49c-.08.34-.19.81-.33,1.43-.32,1.24-.8,3.08-1.49,5.43-1.36,4.7-3.54,11.43-6.42,19.69q-1.1,3.09-2.29,6.47l-1.23,3.44c-.44,1.16-.83,2.36-1.38,3.54a15.4,15.4,0,0,1-5.14,6.09,15.57,15.57,0,0,1-8,2.79l-37.56,2.14-2.88.17h-.2l0-.19c-.84-4.84-1.66-9.58-2.44-14.09l0-.21.21,0,.15,0h0l36.08-11.08-.12.13c3.09-12.23,5.71-22.28,7.62-29.26.95-3.49,1.74-6.21,2.3-8,.3-.92.5-1.62.69-2.08S676.24,301.32,676.24,301.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.89,300.45a8.18,8.18,0,0,0-1.85-3.08A11.48,11.48,0,0,0,683.5,295a13.46,13.46,0,0,0-3.39,2,20.72,20.72,0,0,0-2.56,2.59,3.37,3.37,0,0,1,.51-.84,11.2,11.2,0,0,1,1.85-2,12.92,12.92,0,0,1,8.28-3.06,12,12,0,0,1,8.07,3.52,6.53,6.53,0,0,1,1.42,2.31,4.11,4.11,0,0,1,.18.72A.84.84,0,0,1,697.89,300.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.74,367.13a2.54,2.54,0,0,0-.58,0l-1.67.21-6.29.83-22,3.06-.13,0,0,.13-6.41,18.1c-4.56,13-8.69,24.79-11.7,33.35-1.46,4.25-2.65,7.7-3.49,10.13q-.59,1.75-.93,2.76c-.09.3-.17.53-.23.72a.86.86,0,0,0-.06.25s0-.07.11-.23.16-.42.28-.71c.24-.66.58-1.57,1-2.73L568.29,423c3-8.55,7.21-20.31,11.83-33.3,2.26-6.42,4.42-12.54,6.38-18.12l-.18.15,21.92-3.24,6.27-1,1.66-.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.82,401h4a4.14,4.14,0,0,0,4.11-3.64c.78-6.48,2.34-24.53,2.36-24.71l-2.84-.24c0,.18-1.57,18.18-2.34,24.61a1.3,1.3,0,0,1-1.29,1.14h-4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.82,401a.86.86,0,0,1,0-.17c0-.14,0-.32,0-.54,0-.51,0-1.22,0-2.13v-.07h.07l2.21,0h1.32a5.16,5.16,0,0,0,.69,0,1.19,1.19,0,0,0,.91-.95c0-.24,0-.52.08-.79.05-.55.1-1.11.15-1.7.11-1.17.22-2.42.34-3.73.5-5.26,1.09-11.6,1.73-18.47l0-.17.17,0,2.1.18.73.06.17,0v.17c-.94,9.59-1.78,18.24-2.39,24.52a4.26,4.26,0,0,1-2.33,3.44,4.09,4.09,0,0,1-1.7.44c-.55,0-1,0-1.48,0l-2,0-.51,0h0l.54,0,2,0a6.31,6.31,0,0,0,3.07-.48,4.05,4.05,0,0,0,2.17-3.3c.58-6.28,1.39-14.93,2.29-24.52l.15.18-.73-.06-2.1-.18.18-.16c-.66,6.87-1.28,13.21-1.79,18.47-.13,1.31-.25,2.56-.37,3.73-.06.59-.12,1.15-.17,1.7,0,.27,0,.53-.09.81a1.38,1.38,0,0,1-1.09,1.1,4.6,4.6,0,0,1-.73,0H685l-2.21,0,.07-.06c0,.89,0,1.59,0,2.09,0,.23,0,.41,0,.55A.63.63,0,0,1,682.82,401Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "619.93 401.8 610.32 472.95 614.08 472.94 628.36 404.45 619.93 401.8",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.93,401.8l.54.16,1.6.48,6.31,1.94.07,0v.07c-2.55,12.31-7.8,37.67-13.85,66.92l-.33,1.59,0,.15h-4.12l0-.21c2.72-19.92,5.16-37.72,6.91-50.56.89-6.38,1.6-11.53,2.1-15.09.24-1.76.44-3.13.57-4.07q.1-.68.15-1.05l.06-.35s0,.14,0,.38-.07.61-.13,1.08c-.12.95-.3,2.34-.53,4.12-.47,3.58-1.15,8.75-2,15.15L610.5,473l-.18-.2h3.76l-.18.15c.11-.5.22-1.05.34-1.59,6.13-29.24,11.45-54.58,14-66.88l.05.09-6.23-2-1.61-.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.51,404.45H683a4.28,4.28,0,0,0,4.28-4.28h0a4.28,4.28,0,0,0-4.28-4.28H619.51a4.28,4.28,0,0,0-4.28,4.28h0A4.28,4.28,0,0,0,619.51,404.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.54,374.76l8.66-67.93a4.27,4.27,0,0,0-3.71-4.78h0a4.27,4.27,0,0,0-4.78,3.7l-8.66,67.92a4.28,4.28,0,0,0,3.7,4.79h0A4.28,4.28,0,0,0,696.54,374.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "682.23 401.8 691.84 472.95 688.08 472.94 673.8 404.45 682.23 401.8",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619,404.45c0-.09,14.53-.17,32.44-.17s32.43.08,32.43.17-14.52.18-32.43.18S619,404.55,619,404.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.11,411.68l10.69,26.1-32.41,13.46c-1.09-3.17,13.09-16.35,13.09-16.35L460,418.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.92,429.32a1.43,1.43,0,0,1,1.54,1.13,1.37,1.37,0,0,1-1.11,1.54,1.51,1.51,0,0,1-1.62-1.21,1.42,1.42,0,0,1,1.33-1.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.82,437.83l-1.13-2.8L455,449.17s-1.18,1.23-.59,2.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.89,434.94c.07.16.89-.1,1.88.09s1.68.67,1.8.55-.5-.94-1.7-1.14S466.79,434.81,466.89,434.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.07,437.76c0,.17.83.15,1.64.6s1.27,1.09,1.42,1-.11-1-1.14-1.54S464,437.61,464.07,437.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.83,442.63c.16,0,.05-.91-.71-1.61s-1.65-.73-1.67-.57.64.43,1.26,1S463.67,442.68,463.83,442.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.59,431c.12.12.76-.4,1.68-.71S469,430,469,429.8s-.88-.45-2-.07S465.46,430.91,465.59,431Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.65,428.15l-26.74-62.63s.73-10.61,2.74-13.93,61.59-21.92,61.59-21.92,15.15-3.39,25.16.41,18.59,17.08,15.83,23.46l-.09.2a19.54,19.54,0,0,1-18.28,11.52l-21.34-.4-35.27,9.55,17.61,45.37S462.38,428.32,461.65,428.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.43,389.09l-1.76,28.14-35-2c.39-3.34,18.9-9,18.9-9l.39-18.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.46,405.31a1.45,1.45,0,0,1,.9,1.69,1.39,1.39,0,0,1-1.67.91,1.52,1.52,0,0,1-.94-1.8,1.43,1.43,0,0,1,1.84-.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.67,417.29l.2-3-33.76-.65s-1.6.6-1.48,1.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,406c0,.17.84.3,1.65.89s1.22,1.35,1.38,1.29,0-1.06-1-1.77S437,405.84,437,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.22,407.31c0,.16.68.49,1.22,1.25s.66,1.53.83,1.53.34-1-.35-1.88S433.24,407.14,433.22,407.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.88,411.58c.16.05.44-.79.06-1.75s-1.16-1.39-1.25-1.25.39.67.7,1.47S430.72,411.56,430.88,411.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.53,401.89c.07.16.86,0,1.83.09s1.7.47,1.79.33-.59-.8-1.73-.93S437.46,401.75,437.53,401.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.15,322.93s-10-1-11.33,9.91-3.22,61.74-3.22,61.74L457,396.92,461.53,345l37.71-15.32S454.88,321.64,448.15,322.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.8,308.89s-6.37,17-5.24,18.92,16.68,10,16.68,10l39,15.71a33,33,0,0,0,4.3-16.19c.16-9.84-13.2-27.78-13.2-27.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.11,328.83l-.18.09-.57.25-2.18.93L490,333.52l-28.35,11.66.13-.17c-.44,5.13-.92,10.67-1.41,16.4-1.17,13.4-2.26,25.75-3.11,35.52l0,.18-.17,0L440,395.31l-4.71-.52-1.23-.14-.41-.07H434l1.23.1,4.72.42,17.09,1.64-.19.15c.83-9.77,1.88-22.13,3-35.53.5-5.73,1-11.27,1.43-16.4v-.13l.12,0,28.41-11.51,8.26-3.31,2.22-.87.57-.21C501,328.84,501.11,328.82,501.11,328.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.29,331.05a7.14,7.14,0,0,1-1.1-.32l-2.94-1a63.62,63.62,0,0,0-9.84-2.66,29,29,0,0,0-10.13,0,40.4,40.4,0,0,0-4.07,1.11,5,5,0,0,1,1-.5,17.84,17.84,0,0,1,3-.91,27.09,27.09,0,0,1,10.26-.1,55.92,55.92,0,0,1,9.88,2.8c1.23.46,2.21.86,2.89,1.14A5.44,5.44,0,0,1,532.29,331.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.89,321.94a30,30,0,0,0-3.43-.07c-1.06.05-2.32.2-3.72.34s-2.94.3-4.53.58a21,21,0,0,0-7.74,2.72,24.25,24.25,0,0,0-2.7,2.11,2.78,2.78,0,0,1,.58-.73,12.35,12.35,0,0,1,1.95-1.64,19.84,19.84,0,0,1,7.83-2.89c1.62-.28,3.17-.43,4.57-.56s2.67-.22,3.75-.24a14.39,14.39,0,0,1,2.54.15A3.26,3.26,0,0,1,526.89,321.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.41,304.47,471.8,292l5.12-31.52L492.47,267s-5.36,33.42-7.66,36.63-28.53,11.25-28.53,11.25Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.75,313.64s-7.09,2.55-8.78,3a40.88,40.88,0,0,1-6.8.26s-7.51,3.36-8,3-1.15-.71-.75-1.18,6-3.89,6-3.89l-4.13.88s-5.51,3.05-6,3-1.28-.68-1.08-1.37l.21-.7a1.4,1.4,0,0,1,.14-1.81l.51-.36-.28-.48a2.16,2.16,0,0,1,.42-2.26c1-1.11,2.95-3.53,2.95-3.53l7.29-2.95,15.06-1",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,311.1a9.49,9.49,0,0,1-.7,1,5.38,5.38,0,0,1-2.77,1.56,11.32,11.32,0,0,1-4.78-.22,16.54,16.54,0,0,0-6-.55c-.55.09-1.06.3-1.51.32a.81.81,0,0,1-.87-.64c0-.34.46-.56.89-.77l1.26-.65,4.34-2.26,2.92-1.56a5,5,0,0,0,1-.63,7.29,7.29,0,0,0-1.12.47l-3,1.42-4.39,2.16-1.27.64a6.45,6.45,0,0,0-.67.36,1,1,0,0,0-.47.82,1.25,1.25,0,0,0,1.34,1.11,12.77,12.77,0,0,0,1.57-.32,16.7,16.7,0,0,1,5.87.51,11.2,11.2,0,0,0,4.93.12,5.26,5.26,0,0,0,2.82-1.77,4,4,0,0,0,.48-.8A1.14,1.14,0,0,0,458,311.1Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.16,309.17a63.13,63.13,0,0,1-6.41,1.21c-.44.05-.88.08-1.3.11h-.11l0,.08a16.13,16.13,0,0,1-3.88,3.48,3.65,3.65,0,0,0,1.39-.62,10.08,10.08,0,0,0,2.84-2.57l-.16.09c.43,0,.87,0,1.32-.1a22.4,22.4,0,0,0,4.58-.94A6.32,6.32,0,0,0,443.16,309.17Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.79,313.32c-.08-.12-1.41.88-3.23,1.74s-3.41,1.28-3.38,1.42a7.75,7.75,0,0,0,3.58-1A7.94,7.94,0,0,0,436.79,313.32Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.84,252.58s-5.22-13.44-13.43-14.32l-27.22,1.62-10.92,3.68s-6,9.35-4.78,25.69c.47,6.11,3.09,23,3.44,26.67.33,3.43.69,12.9,4.87,13l41.53.68s9.42-2.44,9.92-8.07S537.84,252.58,537.84,252.58Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.39,283.28a3.5,3.5,0,0,1-.71.58,13,13,0,0,1-2.17,1.22,12.77,12.77,0,0,1-3.56,1,12.17,12.17,0,0,1-4.53-.27,15,15,0,0,1-7-4.2,17.68,17.68,0,0,1-1.59-1.91,3.83,3.83,0,0,1-.48-.78c.07-.05.8,1,2.29,2.47a15.58,15.58,0,0,0,6.87,4,12.72,12.72,0,0,0,7.86-.6C516.31,284,517.34,283.21,517.39,283.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M498.05,279.89a12.13,12.13,0,0,0,4.14,8.23A10,10,0,0,0,511,290.2a8.62,8.62,0,0,0,6.18-6.5,25.24,25.24,0,0,1-6.67,2.2,13,13,0,0,1-12.69-6.25l.33.37"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M545.61,271.18l-21.09,9.47s-8.22-19-8.91-21.6-2.93-6.72-.48-12.06,8.44-8.24,12.36-6.79C536.66,243.59,545.61,271.18,545.61,271.18Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.6,279.35c3.85,6.58,6.55,10.37,6.55,10.37l-35.89,21.06,4,9.69,43.44-17.06a10,10,0,0,0,6.06-6.57,8.12,8.12,0,0,0,0-4.43l-7-20.4Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.75,293.17a30.2,30.2,0,0,0-4.22-2.28,31.37,31.37,0,0,0-4.65-1.18,9.66,9.66,0,0,1,4.81.77A9.53,9.53,0,0,1,541.75,293.17Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.61,271.18a2.29,2.29,0,0,0-.42.14l-1.17.47-4.26,1.81-14,6.11-1.71.75.27.1c-2.34-5-4.38-9.5-5.83-12.74-.69-1.59-1.26-2.88-1.68-3.83l-.46-1a1.61,1.61,0,0,0-.18-.35,2,2,0,0,0,.11.38c.09.24.21.61.39,1.06.35.93.88,2.25,1.57,3.89,1.39,3.27,3.39,7.77,5.71,12.8l.09.18.18-.08,1.7-.76,14-6.21,4.21-1.92,1.13-.55A1.92,1.92,0,0,0,545.61,271.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.58,316.92l8.94-4.09,17.32-1.09,1.42-1,4,9.69s-4.57,2.09-6.95,2.25L479.76,322l-7.61.67Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.28,282l49.86,1.22c1.61,0,3.15.83,3.36,2.44l4.86,36.43,25.68.42a1.5,1.5,0,1,1,0,3l-25.24-.41L474,325l-52-.85-5-38.45A3.28,3.28,0,0,1,420.28,282Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.28,282a2.63,2.63,0,0,0-.79.06,3.34,3.34,0,0,0-2.57,2.82,9.22,9.22,0,0,0,.15,2.05c.19,1.47.4,3.17.64,5.08,1,7.63,2.37,18.64,4.1,32.17l0,.13H422l79.58,1.34,2.15,0a2,2,0,0,0,1.13-.2,1.66,1.66,0,0,0,.78-.89,1.69,1.69,0,0,0-.74-2.08,2.06,2.06,0,0,0-1.12-.23l-1.05,0-8.34-.13-16-.26.19.17c-1.75-13-3.38-25.22-4.84-36.14a2.86,2.86,0,0,0-.89-1.91,3.68,3.68,0,0,0-1.9-.87,17.28,17.28,0,0,0-2-.11l-2,0-7.51-.18-13.34-.3-19-.41L422,282h-1.76l.44,0L422,282l5.08.16,19,.52,13.34.35,7.51.19,2,.05a18.1,18.1,0,0,1,2,.11,3.41,3.41,0,0,1,1.72.79,2.48,2.48,0,0,1,.79,1.72c1.44,10.92,3.06,23.09,4.79,36.14l0,.17h.17l16,.27,8.33.14h1.06a1.69,1.69,0,0,1,.92.18,1.3,1.3,0,0,1,0,2.27,1.77,1.77,0,0,1-.94.15l-2.14,0L422,324l.15.13c-1.78-13.52-3.22-24.52-4.23-32.16-.25-1.9-.48-3.59-.68-5.07a9.83,9.83,0,0,1-.17-2,3.29,3.29,0,0,1,.61-1.54,3.21,3.21,0,0,1,1.86-1.24C420,282,420.28,282,420.28,282Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.11,303.05a3.12,3.12,0,1,1-3.07-3.17A3.13,3.13,0,0,1,450.11,303.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.3,324.67c-.08,0-1.51-9.27-3.21-20.72s-3-20.76-2.95-20.77,1.5,9.27,3.2,20.73S476.37,324.66,476.3,324.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.54,273.19l-11.35-4.8s5.17-19,10.07-22.45,7.43-3.54,7.43-3.54Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.74,185.15c4.7-.77,8.82,1,12.77,3.72a24.19,24.19,0,0,1,9.43,25.89,18.68,18.68,0,0,1-9.22,11.37c-6.13,3.08-13.94,2-19.39-2.19a23.65,23.65,0,0,1-8.78-17.86,22.63,22.63,0,0,1,3.64-13.44,17.28,17.28,0,0,1,11.55-7.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515,201.18c-.68-1.8-.4-3.8-.66-5.71-.59-4.19-3.95-7.57-7.85-9.22-3.63-1.54-8.07-1.23-12.46.17a16.71,16.71,0,0,0-7.85,5.07,13.16,13.16,0,0,0-2.47,11.82l21.47-3a23.76,23.76,0,0,0,6.48,4.3,4.48,4.48,0,0,0,2.24.37,2,2,0,0,0,1.68-1.37A4.23,4.23,0,0,0,515,201.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.15,240.37l.4-40.54a3.5,3.5,0,0,0-3.26-3.44l-18.71-4c-6-.42-9.67,7-9.84,13-.18,6.64-.15,14.76.81,19.68,1.92,9.88,9.58,10.88,9.58,10.88s.27,6.31.43,9.93a7.14,7.14,0,0,0,7.68,2.86C507.6,247.63,515.15,240.37,515.15,240.37Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.46,214.18a1.27,1.27,0,0,0,1.27,1.24,1.22,1.22,0,0,0,1.28-1.19,1.28,1.28,0,0,0-1.28-1.25A1.23,1.23,0,0,0,486.46,214.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.65,209.51c.16.16,1.1-.59,2.48-.63s2.4.61,2.54.43-.1-.37-.55-.67a3.48,3.48,0,0,0-4,.15C485.7,209.13,485.57,209.44,485.65,209.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.63,214.18a1.27,1.27,0,0,0,1.27,1.24,1.21,1.21,0,0,0,1.27-1.19A1.28,1.28,0,0,0,499.9,213,1.23,1.23,0,0,0,498.63,214.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.82,208.58c.16.16,1.11-.58,2.48-.63s2.4.61,2.54.44-.1-.37-.55-.68a3.46,3.46,0,0,0-2-.55,3.33,3.33,0,0,0-2,.71C498.87,208.21,498.74,208.51,498.82,208.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.52,219.64a10,10,0,0,0-2.24-.32c-.36,0-.69-.08-.76-.32a1.78,1.78,0,0,1,.2-1.05c.3-.85.61-1.76.94-2.7a46.72,46.72,0,0,0,2.09-7.06c-.16-.05-1.34,3-2.65,6.88-.31,1-.61,1.85-.9,2.71a2,2,0,0,0-.13,1.39.87.87,0,0,0,.59.49,2.25,2.25,0,0,0,.6.06A8.5,8.5,0,0,0,494.52,219.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.13,235.91a25.29,25.29,0,0,0,13.19-4s-3.11,7-13.09,6.41Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.21,203.07c.15.37,1.51.15,3.12.29s2.94.53,3.14.19c.09-.17-.15-.51-.69-.85a5.05,5.05,0,0,0-2.34-.73,5.12,5.12,0,0,0-2.43.37C498.43,202.6,498.14,202.9,498.21,203.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.84,203.5c.25.3,1.19-.06,2.32-.11s2.11.13,2.32-.2c.09-.16-.07-.47-.5-.75a3.24,3.24,0,0,0-1.91-.44,3.2,3.2,0,0,0-1.83.69C485.85,203,485.73,203.35,485.84,203.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.48,198.3c-1.92-5.71-10.37-13.52-16.37-13l-9.51,5.91a9.24,9.24,0,0,0,6.4,7c1.7.49,3.75.6,4.78,2.05s.49,3.65,1.47,5.17c1.36,2.11,5,2,6,4.24.45,1,.24,2.21.71,3.2.63,1.32,4,3,5.41,2.49s1.35-2.83,1.79-4.08a6.65,6.65,0,0,0,.13-4.42C518.67,204,519.4,201,518.48,198.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.31,216.58c0-.74.77-2.51,1.49-2.65,2-.37,5.47-.34,5.68,4.62.28,6.77-6.59,5.66-6.61,5.46S513.39,219.14,513.31,216.58Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.84,221.36s.12.08.32.16a1.19,1.19,0,0,0,.89,0,2.92,2.92,0,0,0,1.24-2.67,3.92,3.92,0,0,0-.4-1.68,1.36,1.36,0,0,0-.93-.87.6.6,0,0,0-.68.35c-.08.2,0,.33-.07.34s-.15-.1-.11-.39a.81.81,0,0,1,.25-.43.89.89,0,0,1,.65-.2,1.66,1.66,0,0,1,1.28,1,4,4,0,0,1,.48,1.87,3.06,3.06,0,0,1-1.6,3,1.3,1.3,0,0,1-1.09-.14C515.86,221.52,515.82,221.37,515.84,221.36Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.58,189.17c-.64,2.75-4.85,6.27-6.69,8.41-3.53,4.08-4.23,5.44-4.23,14.6-1.65-3.17-2.91-6.27-2.76-9.84a14.79,14.79,0,0,1,4-9.7,11.49,11.49,0,0,1,9.72-3.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.93,198.23a5.66,5.66,0,0,1-1.15.28,13.34,13.34,0,0,1-1.37.23c-.54.07-1.15.18-1.83.21a33,33,0,0,1-4.81,0,37.17,37.17,0,0,1-5.81-.91,36.28,36.28,0,0,1-5.57-1.91,32.56,32.56,0,0,1-4.24-2.27c-.59-.35-1.08-.72-1.52-1a13.17,13.17,0,0,1-1.11-.84,7.78,7.78,0,0,1-.89-.79,7.33,7.33,0,0,1,1,.66c.3.23.68.5,1.14.79s.95.65,1.54,1a35.92,35.92,0,0,0,4.24,2.17,39.91,39.91,0,0,0,5.51,1.86,39.13,39.13,0,0,0,5.75.93,34.93,34.93,0,0,0,4.76,0c.68,0,1.28-.09,1.82-.14s1-.11,1.38-.16A6.29,6.29,0,0,1,521.93,198.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.62,203.09a3,3,0,0,1-.78.19,19.94,19.94,0,0,1-2.19.27,27.11,27.11,0,0,1-14.12-2.83,16.83,16.83,0,0,1-1.91-1.09,2.78,2.78,0,0,1-.65-.47c0-.06,1,.53,2.69,1.31a31.34,31.34,0,0,0,6.82,2.22,30.7,30.7,0,0,0,7.15.57C521.48,203.2,522.61,203,522.62,203.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,177.23a7.89,7.89,0,0,1,5.09-3.51,13,13,0,0,1,6.28.31,13.61,13.61,0,0,1,7.07,4.28,8.56,8.56,0,0,1,1.71,7.87,6.28,6.28,0,0,1-6.42,4.34,18.35,18.35,0,0,1,5.08,5.69c.23.4.43.95.11,1.29s-1,.11-1.44-.18L523.54,194a9.64,9.64,0,0,1,3.18,4.81c.19.67.16,1.61-.5,1.81a1.53,1.53,0,0,1-1.21-.4l-3.51-2.53-7.4-9.3a11,11,0,0,1-3.64-5.07A7.64,7.64,0,0,1,511,177.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.32,185.23c0,.08,1.09.35,2.78,1.08a22.66,22.66,0,0,1,10.55,9.34c.93,1.59,1.34,2.66,1.42,2.63a2.69,2.69,0,0,0-.23-.78,14.75,14.75,0,0,0-.9-2A20.63,20.63,0,0,0,510.23,186a16.06,16.06,0,0,0-2.11-.66C507.61,185.24,507.33,185.19,507.32,185.23Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.09,256a5.17,5.17,0,0,1,.17,1.25c.06.93.13,2.07.22,3.41.17,2.88.35,6.85.68,11.24s.79,8.33,1.24,11.17c.22,1.42.41,2.57.55,3.36a5.23,5.23,0,0,1,.16,1.25,5.35,5.35,0,0,1-.38-1.2c-.21-.78-.46-1.92-.73-3.34a101.54,101.54,0,0,1-1.42-11.2c-.32-4.4-.45-8.38-.51-11.27,0-1.34,0-2.48,0-3.41A6,6,0,0,1,481.09,256Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496,222.77a2.47,2.47,0,0,1,2.32-.63,2.29,2.29,0,0,1,1.44,1,1.42,1.42,0,0,1-.1,1.64,1.65,1.65,0,0,1-1.84.22,5,5,0,0,1-1.61-1.26,1.49,1.49,0,0,1-.34-.45.47.47,0,0,1,.07-.51",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.75,220.86c-.22,0-.41,1.44-1.81,2.33s-2.95.52-3,.73.32.33,1,.43a3.71,3.71,0,0,0,2.49-.52,3.26,3.26,0,0,0,1.42-2C500,221.26,499.86,220.87,499.75,220.86Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.62,427.51l-1,18.63s18.59,7.29,18.74,10.75l-36.19-.68.4-29.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.44,444.36a1.47,1.47,0,0,0-1.05,1.66,1.41,1.41,0,0,0,1.64,1.06,1.55,1.55,0,0,0,1.11-1.77,1.48,1.48,0,0,0-1.83-.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.15,456.21l.16-2.93L307.94,455s1.6.73,1.4,1.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.19,446c0,.18-.89.24-1.77.79S288.06,448,287.9,448s.12-1.09,1.2-1.74S291.23,445.8,291.19,446Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,447.6c0,.18-.74.46-1.35,1.2s-.8,1.52-1,1.51-.27-1,.51-1.91S295,447.43,295,447.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,452.19c-.16,0-.39-.86.08-1.82s1.3-1.32,1.38-1.18-.45.66-.83,1.45S297.2,452.17,297,452.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,441.69c-.07.16-.88-.1-1.88-.05s-1.78.35-1.87.2.67-.77,1.85-.81S291,441.55,291,441.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.81,425.67l-2,22.49,3.58,18.23a2.31,2.31,0,0,1-2,2.74h0a2.33,2.33,0,0,1-2-.73c-3.22-3.52-15-16.51-14.79-18.15.27-1.9.49-23.85.49-23.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.45,469.13l-16.68-20.4-.06,1a3.4,3.4,0,0,0,.68,2.3c1.32,1.77,5.08,6.59,14,16.41a2.34,2.34,0,0,0,2.06.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.86,441.76a1.39,1.39,0,0,1,.26,1.85,1.34,1.34,0,0,1-1.83.28,1.49,1.49,0,0,1-.27-2,1.4,1.4,0,0,1,1.94-.08",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.93,459a5,5,0,0,1,4.72-2c0-.05-.25-.25-.78-.35a3.54,3.54,0,0,0-2,.22,3.65,3.65,0,0,0-1.6,1.29C242.94,458.6,242.88,458.93,242.93,459Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.35,462.07a20.76,20.76,0,0,1,2.05-.84,20.53,20.53,0,0,1,2.22-.14,2.56,2.56,0,0,0-2.33-.34C244.94,461.05,244.23,462,244.35,462.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.2,454.9a21.83,21.83,0,0,1,3.08-1.51,22.52,22.52,0,0,1,3.39-.57,6.34,6.34,0,0,0-6.47,2.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.22,448c.05.14,1.33-.3,2.95-.25s2.88.52,2.94.38a4.43,4.43,0,0,0-2.93-.88A4.51,4.51,0,0,0,240.22,448Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.63,441.4a10.91,10.91,0,0,1,3.06-.35,11.24,11.24,0,0,1,2.94.94s-.19-.34-.68-.67a5.05,5.05,0,0,0-4.51-.45C240.88,441.1,240.6,441.35,240.63,441.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.74,439.79a2.33,2.33,0,0,0,.08-.85,5.83,5.83,0,0,0-.53-2.27,2.66,2.66,0,0,0-1-1.33.93.93,0,0,0-1.06.14,1.52,1.52,0,0,0-.42,1,3.27,3.27,0,0,0,2.67,3.21,3.8,3.8,0,0,0,3.84-1.74,1.33,1.33,0,0,0,.13-1.09.91.91,0,0,0-.92-.55A3.28,3.28,0,0,0,245,437a6.5,6.5,0,0,0-1.65,1.65,2.21,2.21,0,0,0-.4.76,10.62,10.62,0,0,1,2.24-2.12,3,3,0,0,1,1.35-.55.48.48,0,0,1,.51.29.92.92,0,0,1-.13.71,3.4,3.4,0,0,1-3.35,1.47,2.83,2.83,0,0,1-2.3-2.69,1,1,0,0,1,.26-.7.5.5,0,0,1,.59-.09,2.41,2.41,0,0,1,.9,1.11A9.22,9.22,0,0,1,243.74,439.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.23,268.17s5.06,13.53,4.07,26.47c-.39,5-17.29,143.57-17.29,143.57H271.19L277.61,308l-1.87.41s-12.46,55.54-13.48,64.53c-.91,8.09-11.42,66.81-11.42,66.81L230,440l6.66-77.68,7.76-74.52,2.91-21.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,294.7a4.2,4.2,0,0,0,.95.53,10.63,10.63,0,0,0,2.83,1,5.89,5.89,0,0,0,2.1,0,4.34,4.34,0,0,0,2.2-1.06,5.2,5.2,0,0,0,1.33-2.33c.27-.88.42-1.81.61-2.74.73-3.76,1.22-7.19,1.51-9.68.14-1.25.24-2.26.29-3a5,5,0,0,0,0-1.09,5.1,5.1,0,0,0-.22,1.07c-.12.79-.26,1.77-.44,2.93-.37,2.47-.92,5.89-1.64,9.64-.37,1.85-.62,3.73-1.78,4.84a4.78,4.78,0,0,1-3.94,1,12.93,12.93,0,0,1-2.8-.83A4.89,4.89,0,0,0,274,294.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.88,277s-.15-.11-.47-.13a2,2,0,0,0-1.28.41,2.26,2.26,0,0,0-1,1.76,2.26,2.26,0,0,0,3.85,1.44,2.28,2.28,0,0,0,.44-2,2.1,2.1,0,0,0-.7-1.15c-.25-.19-.43-.22-.44-.2a2.54,2.54,0,0,1,.8,1.42,2,2,0,0,1-.43,1.6,1.85,1.85,0,0,1-3.08-1.15,2,2,0,0,1,.73-1.49A2.6,2.6,0,0,1,280.88,277Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.71,286.43a2.88,2.88,0,0,0,.78.12,14.45,14.45,0,0,0,2.14,0A20.53,20.53,0,0,0,254.5,285a20.79,20.79,0,0,0,5.94-3.8,13.85,13.85,0,0,0,1.48-1.55,2.68,2.68,0,0,0,.46-.64c-.07-.06-.8.78-2.16,1.93a23.52,23.52,0,0,1-5.91,3.62,23.15,23.15,0,0,1-6.7,1.69C245.83,286.4,244.72,286.34,244.71,286.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.19,277.45a9.9,9.9,0,0,0,1.05,2.33,25.81,25.81,0,0,0,3.53,4.91,23.58,23.58,0,0,0,4.47,3.82,8.23,8.23,0,0,0,2.1,1.12,21.68,21.68,0,0,0-1.94-1.41,29.55,29.55,0,0,1-4.33-3.88,31,31,0,0,1-3.57-4.75C300.69,278.28,300.25,277.42,300.19,277.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,212.89l2.89-1.77s3.79-3.37,4.82-4.11a24.09,24.09,0,0,1,5.57-2.48c.56.05,6-.3,7.33-.9s2.71-1.4,2.71-1.4a2,2,0,0,1,.14,2.34c-.79,1.35-4.78,3.89-4.78,3.89l1.5,9.78s-3.72,2.93-6,3.13-4.56-.27-5.21-.06-2.29.78-2.29.78Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.35 213.53 388.75 196.69 390.19 198.81 365.03 215.58 363.35 213.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.62,208.55a1.73,1.73,0,0,1,.91,2.57c-1,1.77-2.35,1.22-2.35,1.22a2.64,2.64,0,0,1-1.72,2.94,3.31,3.31,0,0,1-1.28,3l-1.24.64-.78-1.52s-4.65-.43-5.35-2.28l0-1a1.38,1.38,0,0,1-.75-1.36c.15-.9.09-.92,1.84-1.52s5.45-.2,5.45-.2-2-.76-1.95-1.79.83-1.68,3-1.53A21.52,21.52,0,0,1,377.62,208.55Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.62,208.55a5.12,5.12,0,0,1-.77-.17c-.5-.11-1.23-.28-2.18-.42-.47-.06-1-.12-1.57-.15a4.43,4.43,0,0,0-1.78.24,1.31,1.31,0,0,0-.69.62,1.11,1.11,0,0,0-.05.94,2,2,0,0,0,.75.76,5.67,5.67,0,0,0,1,.54l.89.35-1-.07a20.46,20.46,0,0,0-4.56,0,6.47,6.47,0,0,0-1.18.32,4.42,4.42,0,0,0-1.1.49.72.72,0,0,0-.22.47l-.06.31a1.31,1.31,0,0,0,0,.28,1.27,1.27,0,0,0,.67.9l.09.05v.09c0,.31,0,.63,0,1v0a2.12,2.12,0,0,0,.11.21,2.68,2.68,0,0,0,1.05.89,6.87,6.87,0,0,0,1.32.53,15.58,15.58,0,0,0,2.72.54h.09l0,.08c.27.52.53,1,.78,1.52l-.21-.07,1.24-.63h0a3.11,3.11,0,0,0,1.23-2.81v-.1l.09,0a3,3,0,0,0,1.38-1.2,2.3,2.3,0,0,0,.28-1.6l0-.2.19.07a1.51,1.51,0,0,0,1.2-.11,2.38,2.38,0,0,0,.84-.76,2.83,2.83,0,0,0,.45-.88,1.3,1.3,0,0,0,0-.81,1.89,1.89,0,0,0-.72-.89c-.22-.15-.35-.21-.34-.23a2.06,2.06,0,0,1,1.18,1.07,1.55,1.55,0,0,1,.07.89,3.13,3.13,0,0,1-.46,1,2.67,2.67,0,0,1-.89.84,1.74,1.74,0,0,1-1.39.13l.16-.13a2.68,2.68,0,0,1-.28,1.78,3.32,3.32,0,0,1-1.49,1.32l.08-.14a3.71,3.71,0,0,1-.23,1.67,3.23,3.23,0,0,1-1.1,1.42h0L372,219l-.14.07-.08-.14-.79-1.52.13.09a15.63,15.63,0,0,1-2.79-.55,8.44,8.44,0,0,1-1.38-.55,3,3,0,0,1-1.18-1c-.05-.09-.09-.19-.14-.27v0l0-1,.09.14a1.57,1.57,0,0,1-.85-1.16,1.53,1.53,0,0,1,0-.37l.06-.32a1,1,0,0,1,.33-.67,4.8,4.8,0,0,1,1.22-.54,5.71,5.71,0,0,1,1.23-.32,20,20,0,0,1,4.64,0l-.07.28a6,6,0,0,1-1.09-.58,2.45,2.45,0,0,1-.84-.88,1.47,1.47,0,0,1,.89-1.89,4.37,4.37,0,0,1,1.89-.22,13.61,13.61,0,0,1,1.59.19,17.28,17.28,0,0,1,2.17.5l.56.17Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.92,215.33a15.37,15.37,0,0,0-8.18-1.24,3.51,3.51,0,0,1,1.21-.3,10.58,10.58,0,0,1,3,0,10.28,10.28,0,0,1,2.88.87A3.66,3.66,0,0,1,373.92,215.33Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.11,212.47c-.06.07-.92-.5-2.14-.82s-2.24-.42-2.23-.52a4.45,4.45,0,0,1,2.33.19A3.75,3.75,0,0,1,376.11,212.47Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.36,114.93a4.35,4.35,0,0,1,4.48-2.31,6,6,0,0,1,7.34,0,5.3,5.3,0,0,1,8.09,4.17,4.44,4.44,0,0,1,4,7.39,4.26,4.26,0,0,1-1.63,8.31L270.25,119.9A4.37,4.37,0,0,1,269.36,114.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.3,133.07A18.07,18.07,0,0,0,274,116.82l-.93,0c-10.08.8-15,9.8-14,19.85l2.16,33.57,1.47,4.2,17.36,21.75,4.37-19.6.08-9.1s9.67-1.7,9.59-11.4C294.05,151.42,293.19,141.78,292.3,133.07Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.49,167.53A23.49,23.49,0,0,1,271.8,164s3.12,6.94,12.68,5.89Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.68,142.11a1.38,1.38,0,0,1-1.31,1.42,1.32,1.32,0,0,1-1.45-1.22,1.37,1.37,0,0,1,1.3-1.42A1.32,1.32,0,0,1,289.68,142.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.44,138.35c-.17.18-1.24-.58-2.73-.54s-2.56.8-2.73.62.09-.41.56-.76a3.71,3.71,0,0,1,2.18-.72,3.59,3.59,0,0,1,2.17.65C290.36,137.94,290.52,138.26,290.44,138.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.92,143a1.37,1.37,0,0,1-1.3,1.42,1.32,1.32,0,0,1-1.46-1.22,1.38,1.38,0,0,1,1.31-1.42A1.32,1.32,0,0,1,276.92,143Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18,138.43c-.17.19-1.24-.57-2.73-.53s-2.56.8-2.73.62.09-.41.56-.77a3.85,3.85,0,0,1,2.18-.72,3.66,3.66,0,0,1,2.17.65C276.1,138,276.26,138.35,276.18,138.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.31,149.37a10.27,10.27,0,0,1,2.41-.48c.38,0,.74-.13.8-.39a1.94,1.94,0,0,0-.28-1.13c-.37-.91-.77-1.87-1.18-2.87-1.65-4.09-2.85-7.46-2.69-7.53s1.64,3.2,3.29,7.3c.39,1,.77,2,1.14,2.89a2.17,2.17,0,0,1,.22,1.49,1,1,0,0,1-.61.57,2.34,2.34,0,0,1-.65.1A9.39,9.39,0,0,1,281.31,149.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.11,134.18c-.17.39-1.46.07-3,.12s-2.85.41-3,0c-.07-.18.18-.54.72-.88a4.74,4.74,0,0,1,2.3-.66,4.54,4.54,0,0,1,2.3.54C275.93,133.64,276.18,134,276.11,134.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,134.27c-.22.36-1.28.12-2.51.23s-2.24.46-2.52.13c-.12-.16,0-.52.43-.88a3.43,3.43,0,0,1,2-.76,3.48,3.48,0,0,1,2.07.47C289.93,133.76,290.11,134.09,290,134.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.28,128.64s-2.68-6-5.64-7.38c-3.58-1.64-5,2.28-8.42,1.41s-6.82-2.45-10.22.23c-3.72,2.94-1.91,4.91-2.05,9.21-.59,17.47-3.67,22.46-4.75,14.27-.11-.9-2.63-1.57-3.08-5.36-.58-4.92-.89-10.91.14-14.43.86-3,2.5-5,5.47-7.35,4.69-3.65,11.23-3.86,15.68-3.5S291.53,121,291.28,128.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.82,146.1a2.64,2.64,0,0,0-2.9-2.48c-1.8.21-3.79,1.28-3.6,5,.35,6.63,6.93,4.91,6.93,4.72S261,148.87,260.82,146.1Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.68,150.94s-.11.08-.3.18a1.14,1.14,0,0,1-.86.07,2.84,2.84,0,0,1-1.46-2.5,3.79,3.79,0,0,1,.24-1.67,1.32,1.32,0,0,1,.82-.93.58.58,0,0,1,.69.28c.1.18.07.32.1.33s.14-.12.07-.39a.72.72,0,0,0-.28-.4.88.88,0,0,0-.65-.14,1.63,1.63,0,0,0-1.15,1.09,3.93,3.93,0,0,0-.3,1.87,3,3,0,0,0,1.83,2.77,1.23,1.23,0,0,0,1.05-.23C259.68,151.1,259.7,151,259.68,150.94Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.68,133.25a6.29,6.29,0,0,0,2.84,1.24,2.16,2.16,0,0,0,2.36-1.57c.07-.46-.05-1,.24-1.36s1-.31,1.58-.26a4.23,4.23,0,0,0,4.33-3.13,1.78,1.78,0,0,0,2.39.18,9.52,9.52,0,0,0,1.77-2,2.74,2.74,0,0,1,2.25-1.19,6.11,6.11,0,0,0,1.45.29c.87-.09,1.27-1.12,1.38-2s.2-1.88.93-2.36a3.42,3.42,0,0,1,2.37-.11c.8.1,1.83-.11,2-.9a1.61,1.61,0,0,0-.32-1.2,4.3,4.3,0,0,0-5.1-1.52,5.83,5.83,0,0,0-10.72-.91,5.91,5.91,0,0,0-9.39,2.35,4.28,4.28,0,0,0-4.7,6.33,4,4,0,0,0-2.17,3.28,2.34,2.34,0,0,0,2.68,2.33,2.37,2.37,0,0,0,4.15,2.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.67,151.82a.57.57,0,0,0-.44-.07.52.52,0,0,0-.25.31,3.33,3.33,0,0,0,.37,3.2l0,0a2.22,2.22,0,0,0,3.75-.49l.52-1.11Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.76,155.35c.05,0-.44.69-1.64.83a1.82,1.82,0,0,1-1-.16,2.14,2.14,0,0,1-.92-.67,4,4,0,0,1-.66-2.42,5.29,5.29,0,0,1,.05-.67.93.93,0,0,1,.4-.66.8.8,0,0,1,.76,0l.51.26,1.75.91a9,9,0,0,1,1.57.94,7,7,0,0,1-1.7-.66l-1.79-.83c-.33-.13-.75-.41-.89-.29s-.22.58-.23,1a3.83,3.83,0,0,0,.55,2.17,1.78,1.78,0,0,0,.75.58,1.52,1.52,0,0,0,.81.18A3.93,3.93,0,0,0,280.76,155.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.39,130.77a1.57,1.57,0,0,0,.44,1.27,2.11,2.11,0,0,0,1.34.76,2.27,2.27,0,0,0,1.88-.59l-.28,0a6.73,6.73,0,0,0,1.35,1.62,3.68,3.68,0,0,0,1.23.73,2.69,2.69,0,0,0,1.34.1,2.63,2.63,0,0,0,1.89-1.14,3.74,3.74,0,0,0,.5-1.39c.06-.34.07-.53,0-.54s-.08.18-.18.5a4.62,4.62,0,0,1-.59,1.28,2.7,2.7,0,0,1-4,.17,6.52,6.52,0,0,1-1.29-1.52l-.12-.19-.16.15a2,2,0,0,1-1.59.55,2,2,0,0,1-1.21-.61A3,3,0,0,1,256.39,130.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.6,115.37a3.07,3.07,0,0,0,.47.16,2.37,2.37,0,0,1,1.05.86l.08.12.09-.12a8.22,8.22,0,0,1,3.15-2.66,6.46,6.46,0,0,1,2.6-.63,5.42,5.42,0,0,1,2.83.75,5.51,5.51,0,0,1,1.7,1.55,4.46,4.46,0,0,1,.77,2l0,.21.19-.06a3.65,3.65,0,0,1,4.31,1.86,5,5,0,0,1,.45,2,1.23,1.23,0,0,0,.07-.55,3.79,3.79,0,0,0-1.92-3.25,4,4,0,0,0-3-.36l.23.15a4.85,4.85,0,0,0-.81-2.16,5.83,5.83,0,0,0-4.85-2.45,6.63,6.63,0,0,0-2.73.7,8.06,8.06,0,0,0-3.18,2.84h.17a2.28,2.28,0,0,0-1.18-.84A1.11,1.11,0,0,0,268.6,115.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.35,192.75s-11.27,48.55-10.09,63.37,3.46,36.59,3.46,36.59l15.85-.88L242,251.4l6.55-29.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.61,274.89s-16.17-2.36-16.81-6,3.28-30.76,3.28-30.76l-3-17.79-11.71-26.26c-.64-2.2,3.3-8.5,5.33-9.56l18.88-9.91,2.44-7,7.71,75.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.26,208.5l-23.89,11-.54-.78L313.72,187a17.16,17.16,0,0,0-10.2-8.29l-14.9-4.43-4.13-3.64-3.31,5.12-1.8,7.51-2.87-7.11-15.44-8.61-.26,4.47-5.55,16.41,4.6,42.81v43.22s12.92,2.22,21,1.67c4.65-.32,11.79-2,17-3.31h0c1.91-.49,3.56-.94,4.75-1.27l3.39-.91,3.33-4.18-.68-25.19,1.16-19.51,9,13.45a12.45,12.45,0,0,0,16.65,2.9l26.25-15.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,275.58s0-.08,0-.23,0-.39,0-.68c0-.61-.06-1.49-.1-2.6-.08-2.28-.19-5.55-.32-9.57-.28-8.09-.73-19.25-1.36-31.58s-1.35-23.48-1.91-31.54c-.28-4-.51-7.28-.67-9.56-.07-1.11-.13-2-.17-2.6,0-.28,0-.51,0-.68v-.23a.89.89,0,0,1,0,.23c0,.17,0,.39.07.68.05.61.13,1.48.24,2.59.2,2.25.46,5.51.77,9.55.62,8.06,1.36,19.22,2,31.55s1.05,23.49,1.27,31.58c.11,4,.18,7.31.21,9.58,0,1.11,0,2,0,2.6v.68A.82.82,0,0,1,284.44,275.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.62,192.75a1.61,1.61,0,0,1,0,.48c0,.34,0,.8,0,1.37,0,1.24.05,3,.09,5.07.06,4.28.08,10.19,0,16.72s-.2,12.44-.34,16.71c-.08,2.11-.15,3.83-.19,5.07,0,.57-.06,1-.07,1.37a2.53,2.53,0,0,1-.05.48,2.58,2.58,0,0,1,0-.48c0-.35,0-.81,0-1.38,0-1.23,0-2.95.08-5.06.08-4.28.17-10.19.24-16.72s.08-12.43.08-16.71c0-2.11,0-3.83,0-5.07,0-.57,0-1,0-1.37A2.91,2.91,0,0,1,309.62,192.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.08,238.1c-.14,0-1.84-9.49-3.79-21.25s-3.42-21.32-3.28-21.34,1.84,9.49,3.79,21.25S249.22,238.08,249.08,238.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.16,176.63a9.87,9.87,0,0,1-1.14,1.7c-.76,1-1.86,2.51-3.16,4.2l-.12.15-.18-.08c-1.08-.5-2.26-1.07-3.48-1.7a73.4,73.4,0,0,1-6.81-4,15.84,15.84,0,0,1-2.62-2,27,27,0,0,1,2.82,1.66c1.72,1.05,4.13,2.45,6.85,3.88,1.21.63,2.38,1.21,3.45,1.72l-.29.07c1.32-1.67,2.48-3.09,3.3-4.08A10.19,10.19,0,0,1,276.16,176.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,174.47a17.55,17.55,0,0,1-3,5.83l-.41.56-.19.26-.21-.24a36.4,36.4,0,0,1-3.63-4.6,33.73,33.73,0,0,1,4,4.26h-.41l.41-.55C287.7,177.09,288.88,174.41,289,174.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.36,230.85a12.71,12.71,0,0,1,.07-6,12.92,12.92,0,0,1,2.33-5.49,48.11,48.11,0,0,0-1.82,5.6A46.91,46.91,0,0,0,329.36,230.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.42,
    y: 303.61,
    width: 56.39,
    height: 40.25,
    rx: 4.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.29,343.85a5.39,5.39,0,0,0,1.81-.43,4.6,4.6,0,0,0,1.73-1.41,4.53,4.53,0,0,0,.88-2.87c0-4.72,0-11.5-.08-19.88,0-2.09,0-4.29,0-6.58,0-1.15,0-2.32,0-3.51a11.37,11.37,0,0,0-.07-1.76,4.29,4.29,0,0,0-3.53-3.52,14.57,14.57,0,0,0-1.89-.06h-2l-8.11,0-36.1,0a4.25,4.25,0,0,0-3.7,2.16,4.32,4.32,0,0,0-.56,2.13v11.56c0,6,0,11.86,0,17.41v2.07a4.34,4.34,0,0,0,.37,1.89,4.3,4.3,0,0,0,2.79,2.38,6.54,6.54,0,0,0,1.89.16h5.69l13.72,0,19.88.08,5.41.05,1.4,0,.48,0-.48,0-1.4,0L256,344l-19.88.09-13.72,0h-5.69a7.29,7.29,0,0,1-2-.17,4.71,4.71,0,0,1-3.09-2.63,4.65,4.65,0,0,1-.43-2.08v-2.07c0-5.55,0-11.37,0-17.41V308.16a4.92,4.92,0,0,1,.62-2.39,4.81,4.81,0,0,1,4.16-2.42l36.1,0h10.07a13,13,0,0,1,2,.07,4.76,4.76,0,0,1,3.2,2.11,4.61,4.61,0,0,1,.68,1.78,11.42,11.42,0,0,1,.07,1.83c0,1.19,0,2.36,0,3.51,0,2.29,0,4.49,0,6.58,0,8.38-.06,15.16-.08,19.88a4.59,4.59,0,0,1-1,3,4.5,4.5,0,0,1-1.81,1.41,4.38,4.38,0,0,1-1.37.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,303.63a1.09,1.09,0,0,0-1.38,1.09c0,1.12.92,8.71.92,8.71s2.37,8.44,1.73,9.39a1.54,1.54,0,0,1-2.41.11c-.33-.44-3-7.49-3-7.49l-.68-3.84s1.37,12.15.6,13.1a1.33,1.33,0,0,1-2.13.1c-.53-.48-1.08-5.85-1.08-5.85l-1.25-7.17.17,11.64s-.14,1.3-1.16,1.34c-1.4.06-1.69-1.45-1.69-1.45l-1.42-12.05s.47,7.82,0,8.23c-.7.55-1.35.37-1.58-.23-.47-1.22-1.15-8.26-1.15-8.26l-.65-13.4-.65-5,13-.72.08,2.24s5,3.74,6,5.21a16.56,16.56,0,0,1,1.95,4.25Z",
    style: {
      fill: "#ae7461"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,396.77h-4a4.14,4.14,0,0,1-4.1-3.64c-.79-6.48-2.34-24.53-2.36-24.71l2.83-.24c0,.18,1.57,18.18,2.35,24.61a1.29,1.29,0,0,0,1.28,1.13h4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,396.77s0-.06,0-.17,0-.32,0-.54c0-.51,0-1.22,0-2.14v-.06H60l-2.21,0H56.5a5,5,0,0,1-.68,0,1.16,1.16,0,0,1-.59-.33,1.11,1.11,0,0,1-.33-.62c0-.25,0-.52-.07-.79,0-.55-.11-1.12-.16-1.7-.11-1.17-.22-2.42-.34-3.73-.49-5.27-1.08-11.6-1.73-18.47V368l-.17,0-2.1.18-.74.06h-.17l0,.17c.93,9.6,1.78,18.24,2.39,24.52a4.26,4.26,0,0,0,2.32,3.45,4.13,4.13,0,0,0,1.71.44c.54,0,1,0,1.48,0l2,0,.52,0h0l-.53,0-2,0a6.28,6.28,0,0,1-3.07-.47,4.05,4.05,0,0,1-2.17-3.3c-.59-6.29-1.4-14.93-2.29-24.52l-.16.18.74-.06,2.1-.18-.19-.16c.67,6.87,1.28,13.2,1.8,18.47.13,1.31.25,2.56.37,3.73,0,.58.11,1.15.17,1.69,0,.28,0,.54.08.81a1.48,1.48,0,0,0,.39.73,1.47,1.47,0,0,0,.7.38,3.64,3.64,0,0,0,.73,0h1.32L60,394l-.06-.07c0,.9,0,1.6,0,2.1,0,.23,0,.41,0,.55S60,396.76,60,396.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.92 397.59 132.54 468.73 128.77 468.73 114.5 400.24 122.92 397.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.92,397.59l-.53.15-1.61.49-6.31,1.93-.07,0,0,.08c2.54,12.31,7.79,37.67,13.85,66.92l.33,1.59,0,.14h4.11l0-.21c-2.73-19.92-5.16-37.72-6.92-50.56-.88-6.38-1.6-11.53-2.09-15.1-.25-1.75-.44-3.12-.58-4.06-.06-.46-.11-.8-.15-1.05a2.83,2.83,0,0,0-.06-.35s0,.13,0,.38.08.61.14,1.07c.12,1,.3,2.34.53,4.12.47,3.59,1.15,8.75,2,15.16,1.71,12.81,4.08,30.57,6.74,50.44l.18-.21h-3.77l.18.14c-.1-.5-.22-1-.33-1.59-6.14-29.23-11.46-54.57-14-66.88l-.06.1,6.23-2,1.62-.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.34,400.24H59.89A4.28,4.28,0,0,1,55.61,396h0a4.28,4.28,0,0,1,4.28-4.28h63.45a4.28,4.28,0,0,1,4.28,4.28h0A4.28,4.28,0,0,1,123.34,400.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.32,370.54l-8.66-67.92a4.28,4.28,0,0,1,3.7-4.79h0a4.28,4.28,0,0,1,4.79,3.71l8.66,67.92a4.28,4.28,0,0,1-3.71,4.79h0A4.28,4.28,0,0,1,46.32,370.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.63 397.59 51.02 468.73 54.78 468.73 69.05 400.24 60.63 397.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.87,400.24c0-.09-14.52-.17-32.43-.17s-32.44.08-32.44.17,14.52.17,32.44.17S123.87,400.34,123.87,400.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.07,215.83a4.07,4.07,0,0,0-4.65-3.5,5.21,5.21,0,0,0-6.89-2.11c-1.12.62-2,1.65-3.05,2.31A36,36,0,0,1,59.11,214a3.71,3.71,0,0,0-2.31,2.66A3.25,3.25,0,0,0,59,219.75a9.63,9.63,0,0,0,4,.36,1.4,1.4,0,0,0-.42,1.82,2.84,2.84,0,0,0,1.56,1.26A6.23,6.23,0,0,0,70.54,222l2.54-2A4.06,4.06,0,0,0,77.07,215.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.71,224.33a1.33,1.33,0,0,1-1.79,0,1.81,1.81,0,0,1-.44-1.83A2.88,2.88,0,0,1,69.7,221a6.65,6.65,0,0,1,1.82-.77,12.82,12.82,0,0,1,3-.57,2.43,2.43,0,0,1,1.07.13,1,1,0,0,1,.65.8c0,.51-.4.91-.81,1.21a31.32,31.32,0,0,1-4.86,3",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.22,224.07c-2.41-2.69-8.42-2.33-9.85-.58a4.57,4.57,0,0,0-6,1.95L47,226.79A6.63,6.63,0,0,0,43.89,228a2.3,2.3,0,0,0-.56,3,3.47,3.47,0,0,0-1.5,5.54,2.41,2.41,0,0,0,.33,3.5A24.4,24.4,0,0,0,38,247.11a4.89,4.89,0,0,0-.34,3.37c.39,1.08,1.8,1.83,2.74,1.17a2.81,2.81,0,0,0-.15,3c-1.08,0-1.42,1.69-.68,2.48a3.93,3.93,0,0,0,3,.86,5.31,5.31,0,0,1,3.14.56,1,1,0,0,1-.36.69,4.43,4.43,0,0,0-1,6l.35.5a9.59,9.59,0,0,0,3.12,2.22c2.43,1.3,3.89,1.07,6.61,1.48-.75,1.75,3.65,5.68,8.74,1.89a98,98,0,0,0,27.85,4c1.5,0,3.29-.18,4-1.51a3.7,3.7,0,0,0,3.43-1.1,10.76,10.76,0,0,0,2-3.14,6.52,6.52,0,0,0,4.73-5.83,8,8,0,0,0,3.07-5.7,4.73,4.73,0,0,0,2.76-6.36,28.58,28.58,0,0,0-3-8.83c1.72-.36,2.38-2.67,1.68-4.28s-2.24-2.65-3.71-3.6c1.28.35,2.4-1.25,2.11-2.54a5.08,5.08,0,0,0-2.58-2.88,24.52,24.52,0,0,0-5.29-2.41c-.6-2.26-3.46-4.84-5.57-5.86-8.48-4.09-14.44-5.15-25.35,2.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.26,237.73c-.12-1.79-.41-3.56,1.36-3.83l18.1-5.45c5.83-.89,10.06,6.15,10.69,12,.71,6.52,1.32,14.5.77,19.42a15,15,0,0,1-9.82,12.53l.08,8.6c-.75,4.61-1.77,7.19-3.65,9-6.4-1.19-16.88-15.27-16.88-15.27Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,255.38a9.14,9.14,0,0,1,2.19-.5c.34,0,.66-.13.71-.37a1.72,1.72,0,0,0-.28-1c-.36-.83-.74-1.69-1.14-2.59a44.45,44.45,0,0,1-2.6-6.78,47.26,47.26,0,0,1,3.14,6.55c.39.91.75,1.78,1.1,2.61a2,2,0,0,1,.24,1.35.86.86,0,0,1-.54.53,2.41,2.41,0,0,1-.59.11A8.84,8.84,0,0,1,83.34,255.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.36,272.42a32.22,32.22,0,0,1-12-4s2.15,6.27,12,7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.56,240.3c-.11.37-1.47.26-3,.52s-2.84.75-3.07.43c-.1-.15.11-.51.61-.89a5.41,5.41,0,0,1,4.66-.73C77.31,239.84,77.61,240.12,77.56,240.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.58,240.07c-.22.32-1.17,0-2.29.08s-2.06.3-2.29,0c-.11-.15,0-.47.43-.78a3.31,3.31,0,0,1,3.7-.05C90.54,239.61,90.68,239.92,90.58,240.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.23,245.18A6.71,6.71,0,0,0,95.6,241a25.27,25.27,0,0,1-1.82-1.76c-1.1-1.45-1-3.46-1.42-5.22a7.4,7.4,0,0,0-4.59-5c-1.84-.66-3.93-.57-5.66-1.49-1.27-.67-2.25-1.85-3.56-2.45-2.56-1.17-5.53.15-8,1.59-.47,1.92.74,3.58,1.91,5.18a6.87,6.87,0,0,0,5,2.74c1.53.09,3.32-.25,4.4.84s.7,3.18,1.63,4.49c1.33,1.89,4.36,1.17,6.36,2.33,1.53.9,2.18,2.74,3,4.35s2.11,3.28,3.89,3.19A20.29,20.29,0,0,0,97.23,245.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.43,230.14a34.92,34.92,0,0,0-13.14,2.38,6.33,6.33,0,0,0-3.23,2.24,6.17,6.17,0,0,0-.69,3.4c.05,3.68,1.53,8.17,2.94,11.57l4.59,2.74c3.53-.83,1.9-6.94,1.73-10a7.2,7.2,0,0,0,4.21-6.38A8,8,0,0,0,74.43,230.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.83,251.15c-.14-2.1-2.72-2.5-4.52-1.42-1,.6-1.74,1.77-1.61,4,.34,6,6.25,4.38,6.25,4.21S65,253.61,64.83,251.15Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,255.79s-.1.08-.27.17A1,1,0,0,1,62,256a2.6,2.6,0,0,1-1.32-2.23,3.46,3.46,0,0,1,.21-1.5,1.21,1.21,0,0,1,.73-.85.54.54,0,0,1,.63.25c.09.17.06.29.09.29s.12-.1.06-.35a.63.63,0,0,0-.26-.35.75.75,0,0,0-.58-.12,1.48,1.48,0,0,0-1,1,3.55,3.55,0,0,0-.26,1.68,2.7,2.7,0,0,0,1.66,2.48,1.09,1.09,0,0,0,.94-.21C63,255.93,63,255.8,63,255.79Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.34,258.29a.24.24,0,0,1,0,.08.79.79,0,0,1-.08.23,1.33,1.33,0,0,1-.69.61,3.38,3.38,0,0,1-1.47.31,5.22,5.22,0,0,1-.95-.06,3.58,3.58,0,0,1-1.05-.31l.08,0A3,3,0,0,1,53.44,261l.11,0a1.27,1.27,0,0,1-.78.52,1.79,1.79,0,0,1-1-.08,1.58,1.58,0,0,1-.77-.63,2,2,0,0,1-.31-1,3,3,0,0,1,.65-2,8.76,8.76,0,0,1,1.57-1.53v.13A2.11,2.11,0,0,1,52,255a3,3,0,0,1,.17-1.75,4.77,4.77,0,0,1,1-1.49,14.77,14.77,0,0,1,1.41-1.19v.13A2.22,2.22,0,0,1,54,249a3.22,3.22,0,0,1,.67-1.77,8.13,8.13,0,0,1,2.9-2l-.05.11a4,4,0,0,1,4.29-4.89l-.09.11a3.55,3.55,0,0,1,3.32-4.14l-.08.08a3.36,3.36,0,0,1,1.35-2.6,3.29,3.29,0,0,1,2.49-.69l-.07.06a3.33,3.33,0,0,1,.48-1.53,4.44,4.44,0,0,1,.9-1.09,3.46,3.46,0,0,1,2-.88h.43c.13,0,.26,0,.38,0a3.55,3.55,0,0,1,.56.16l.34.14.11,0-.12,0-.34-.12a3.66,3.66,0,0,0-.56-.15c-.12,0-.24,0-.37,0h-.21l-.22,0a3.37,3.37,0,0,0-2,.88,4.12,4.12,0,0,0-.87,1.08,3.14,3.14,0,0,0-.45,1.47v.07H68.8a3.15,3.15,0,0,0-2.39.68,3.2,3.2,0,0,0-1.28,2.49v.07h-.07a3.23,3.23,0,0,0-2.4,1.19,3.3,3.3,0,0,0-.76,2.76l0,.11h-.12a3.78,3.78,0,0,0-4.09,4.67l0,.07-.07,0a7.92,7.92,0,0,0-2.84,2A3.12,3.12,0,0,0,54.2,249a2.06,2.06,0,0,0,.54,1.59l.07.07-.08.06a7,7,0,0,0-2.4,2.61,2.92,2.92,0,0,0-.16,1.65,2,2,0,0,0,.86,1.3l.11.06-.1.08a8.72,8.72,0,0,0-1.54,1.49,2.88,2.88,0,0,0-.62,1.88,1.59,1.59,0,0,0,1,1.48,1.31,1.31,0,0,0,1.58-.38l0-.06.06,0a2.89,2.89,0,0,0,3,.29,2.93,2.93,0,0,0,1.53-2.07V259l.06,0a3.26,3.26,0,0,0,1,.31,5.26,5.26,0,0,0,.94.08,3.66,3.66,0,0,0,1.45-.28,1.39,1.39,0,0,0,.69-.59C62.31,258.4,62.33,258.29,62.34,258.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.67,251.93a1.85,1.85,0,0,1-.23-.36,3,3,0,0,1-.31-1.18,2.94,2.94,0,0,1,.48-1.86,3.19,3.19,0,0,1,2.16-1.38l-.05.07a4.11,4.11,0,0,1,.53-2.93,4,4,0,0,1,1.17-1.24,9,9,0,0,1,1.63-.77,3.63,3.63,0,0,0,.78-.46,2.17,2.17,0,0,0,.54-.73c.26-.57.35-1.25.68-1.86a3.61,3.61,0,0,1,3.62-1.8l-.1.1a4.77,4.77,0,0,1,5.28-5.41l-.1.1A4.28,4.28,0,0,1,58,228.06a4.32,4.32,0,0,1,4.29.24h-.1A5.84,5.84,0,0,1,64.24,227a8.66,8.66,0,0,1,2.14-.49,10.24,10.24,0,0,1,3.53.24,7.09,7.09,0,0,1,2.09.87,4.06,4.06,0,0,1,.49.35l.15.13s-.22-.17-.66-.44a7.21,7.21,0,0,0-2.09-.82,10,10,0,0,0-3.5-.2,8.38,8.38,0,0,0-2.1.49,5.67,5.67,0,0,0-2,1.25l0,.05,0,0a4,4,0,0,0-6.25,3.77v.11h-.11a4.59,4.59,0,0,0-5.08,5.2l0,.12-.12,0a3.46,3.46,0,0,0-3.45,1.71c-.32.57-.4,1.24-.68,1.84a2.22,2.22,0,0,1-.59.79,3.63,3.63,0,0,1-.82.49,10,10,0,0,0-1.61.74,4,4,0,0,0-1.13,1.19,4,4,0,0,0-.54,2.84l0,.06h-.07a3,3,0,0,0-2.59,3.12,3.32,3.32,0,0,0,.28,1.17C39.59,251.81,39.67,251.92,39.67,251.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.58,253.54a.63.63,0,0,1,0-.49,1,1,0,0,1,.35-.49,1.86,1.86,0,0,1,.73-.37,3.49,3.49,0,0,0,.93-.39,1.84,1.84,0,0,0,.67-1,3.54,3.54,0,0,0,.15-1.36c0-.49-.1-1-.1-1.57a16.16,16.16,0,0,1,.76-3.52,4.91,4.91,0,0,0,.08-1.95,2.42,2.42,0,0,0-1.08-1.68,9,9,0,0,0-2.09-.7,3.72,3.72,0,0,1-1.07-.5,2.47,2.47,0,0,1-.75-.94,11.22,11.22,0,0,1-.62-2.34,3.93,3.93,0,0,0-.42-1.13,1.81,1.81,0,0,0-.87-.77,6.91,6.91,0,0,0-1.65-.22,2.67,2.67,0,0,1-.83-.21,1.64,1.64,0,0,1-.66-.56,6,6,0,0,1-.63-1.52,3.66,3.66,0,0,0-.74-1.34,3.6,3.6,0,0,0-2.59-1.24,3.72,3.72,0,0,0-2.53.91l-.08.08,0-.1a5.66,5.66,0,0,0-3.54-3.05,5.1,5.1,0,0,0-2-.17,4.71,4.71,0,0,0-1.63.45,4.16,4.16,0,0,0-1.74,1.6,3,3,0,0,0-.29.56l-.08.15,0,.05s0,0,0-.06l.06-.15a4.06,4.06,0,0,1,.28-.57,4.1,4.1,0,0,1,1.74-1.66,4.82,4.82,0,0,1,1.66-.48,5.35,5.35,0,0,1,2,.16,5.78,5.78,0,0,1,3.64,3.1l-.12,0a3.75,3.75,0,0,1,5.35.32,3.94,3.94,0,0,1,.78,1.4,6,6,0,0,0,.6,1.48,1.79,1.79,0,0,0,1.37.69,6.67,6.67,0,0,1,1.69.23,2,2,0,0,1,1,.85,4,4,0,0,1,.43,1.18,11.94,11.94,0,0,0,.61,2.3,2.25,2.25,0,0,0,.7.88,3.33,3.33,0,0,0,1,.47,9,9,0,0,1,2.12.73,2.33,2.33,0,0,1,.78.78,2.94,2.94,0,0,1,.37,1,5.06,5.06,0,0,1-.09,2,15.93,15.93,0,0,0-.77,3.48c0,.55.07,1.07.08,1.57a3.53,3.53,0,0,1-.17,1.39,1.92,1.92,0,0,1-.71,1,3.54,3.54,0,0,1-1,.38,1.94,1.94,0,0,0-.72.35,1.11,1.11,0,0,0-.35.46A.73.73,0,0,0,96.58,253.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.13,244.32l-.06-.11c0-.09-.1-.2-.17-.34-.14-.3-.35-.73-.61-1.29s-.57-1.25-1-2a5.25,5.25,0,0,0-2-2.13c-.48-.26-1-.44-1.59-.69a3.49,3.49,0,0,1-.81-.47,2,2,0,0,1-.61-.78c-.28-.61-.29-1.31-.52-2a1.64,1.64,0,0,0-.57-.82,3.25,3.25,0,0,0-1-.44,5.64,5.64,0,0,1-1-.4,1.93,1.93,0,0,1-.81-.84,8.39,8.39,0,0,1-.51-2.31,2.92,2.92,0,0,0-.4-1.09,1.51,1.51,0,0,0-.94-.63c-.78-.16-1.63.11-2.5,0a2.09,2.09,0,0,1-1.14-.61,5.09,5.09,0,0,1-.74-1c-.22-.36-.42-.71-.66-1a2.24,2.24,0,0,0-.87-.75,3.54,3.54,0,0,0-2.25,0,5.27,5.27,0,0,1-2.26.2,6,6,0,0,1-2-.9,10.5,10.5,0,0,0-1.75-1,6.19,6.19,0,0,0-3.53-.11,6.52,6.52,0,0,0-2.61,1.35,7.34,7.34,0,0,0-1.45,1.7,9.92,9.92,0,0,0-.62,1.28c0,.15-.1.26-.13.35s-.05.12-.06.12a.63.63,0,0,1,0-.13l.12-.35a8,8,0,0,1,.59-1.3,7.17,7.17,0,0,1,1.44-1.75,6.68,6.68,0,0,1,2.65-1.4,6.29,6.29,0,0,1,3.61.1,10.44,10.44,0,0,1,1.79,1,5.92,5.92,0,0,0,1.91.87,5.17,5.17,0,0,0,2.19-.21,8.78,8.78,0,0,1,1.16-.2,2.49,2.49,0,0,1,1.2.19,2.46,2.46,0,0,1,.95.8,11.38,11.38,0,0,1,.66,1,4.74,4.74,0,0,0,.72,1,1.9,1.9,0,0,0,1,.56c.81.13,1.66-.14,2.51,0a1.66,1.66,0,0,1,1,.69A3,3,0,0,1,97,229.7a9,9,0,0,0,.49,2.26,1.78,1.78,0,0,0,.74.77,6.3,6.3,0,0,0,1,.39,3.45,3.45,0,0,1,1,.47,1.9,1.9,0,0,1,.62.89c.23.68.24,1.37.5,2a2.46,2.46,0,0,0,1.35,1.19c.54.24,1.1.42,1.6.69a5.51,5.51,0,0,1,2,2.2c.42.78.72,1.48,1,2l.59,1.31.15.34A1.26,1.26,0,0,1,108.13,244.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,238.09l.1,0a.74.74,0,0,1,.32.07,1.28,1.28,0,0,1,.59,1.06,3.27,3.27,0,0,1-.12.89,3.7,3.7,0,0,0-.16,1,2.35,2.35,0,0,0,.42,1.1c.23.36.53.71.76,1.13a1.68,1.68,0,0,1,.15,1.5c-.19.51-.55.93-.73,1.45a2.21,2.21,0,0,0,.16,1.64c.23.54.56,1.07.79,1.67a2.84,2.84,0,0,1,.19,1,2.27,2.27,0,0,1-.23,1,11.15,11.15,0,0,1-1.13,1.7,2.72,2.72,0,0,0-.62,1.88,8.52,8.52,0,0,0,.72,2,3.42,3.42,0,0,1,.22,1.1,2.66,2.66,0,0,1-.28,1.07,9.42,9.42,0,0,1-1.28,1.68,4.8,4.8,0,0,0-1,1.68,16.9,16.9,0,0,1-.62,1.86,2.22,2.22,0,0,1-.61.75,2.73,2.73,0,0,1-.84.41,6.59,6.59,0,0,0-.82.29,2.8,2.8,0,0,0-.69.47,6.12,6.12,0,0,0-1,1.27c-.28.45-.53.88-.82,1.27a4.1,4.1,0,0,1-2.07,1.53,4.24,4.24,0,0,1-1.94.18,3.92,3.92,0,0,1-1.19-.34,2.93,2.93,0,0,1-.37-.22,4.34,4.34,0,0,0,3.47.28,4,4,0,0,0,2-1.5c.28-.39.52-.82.8-1.27a6,6,0,0,1,1-1.31,2.81,2.81,0,0,1,.72-.5,6.47,6.47,0,0,1,.84-.3,2.77,2.77,0,0,0,.79-.39,1.93,1.93,0,0,0,.56-.7,13.53,13.53,0,0,0,.6-1.83,5,5,0,0,1,1.07-1.75,9.06,9.06,0,0,0,1.26-1.64,2.47,2.47,0,0,0,.26-1,3,3,0,0,0-.21-1,8.71,8.71,0,0,1-.73-2.06,2.22,2.22,0,0,1,.14-1.08,4.37,4.37,0,0,1,.52-.92,11.33,11.33,0,0,0,1.12-1.67,2.24,2.24,0,0,0,.21-.91,2.59,2.59,0,0,0-.18-.91c-.21-.58-.54-1.11-.78-1.67a2.43,2.43,0,0,1-.16-1.75c.2-.55.57-1,.75-1.45a1.58,1.58,0,0,0-.13-1.39c-.22-.41-.51-.76-.75-1.13a2.48,2.48,0,0,1-.42-1.16,3.72,3.72,0,0,1,.17-1.05,3.27,3.27,0,0,0,.14-.87,1.22,1.22,0,0,0-.54-1A.84.84,0,0,0,101.8,238.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.82,257.32a2.94,2.94,0,0,0-.89.51,4,4,0,0,0-1.44,2.38,4.31,4.31,0,0,0,0,2,4.73,4.73,0,0,0,1.09,2,4.93,4.93,0,0,0,2.07,1.36,4.54,4.54,0,0,0,2.66.06,4.81,4.81,0,0,0,2.26-1.39,4.3,4.3,0,0,0,1.09-2.22A4.67,4.67,0,0,0,64.53,258a4.15,4.15,0,0,0-1.36-.87,4.54,4.54,0,0,0-1.17-.31,2.53,2.53,0,0,0-.77,0,1,1,0,0,0-.25.08,3.61,3.61,0,0,1,1,0,4.4,4.4,0,0,1,1.13.34,4,4,0,0,1,1.29.87,4.47,4.47,0,0,1,1.08,3.76,4.2,4.2,0,0,1-1,2.11,4.61,4.61,0,0,1-2.17,1.32,4.32,4.32,0,0,1-2.52-.05,4.74,4.74,0,0,1-2-1.29,4.59,4.59,0,0,1-1.06-1.87,4.13,4.13,0,0,1-.08-1.87A4.07,4.07,0,0,1,58,257.9,7.37,7.37,0,0,1,58.82,257.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.55,249.24a1.27,1.27,0,0,1-1.18,1.35,1.24,1.24,0,0,1-1.39-1.1,1.3,1.3,0,0,1,1.19-1.36A1.23,1.23,0,0,1,78.55,249.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.69,248.66A1.29,1.29,0,0,1,89.5,250a1.23,1.23,0,0,1-1.38-1.11,1.29,1.29,0,0,1,1.19-1.35A1.23,1.23,0,0,1,90.69,248.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.45,244.57c-.13.2-1.11-.47-2.38-.33s-2.11,1-2.27.81,0-.41.4-.8a2.87,2.87,0,0,1,3.7-.38C90.34,244.18,90.51,244.49,90.45,244.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.33,245.62c-.18.2-1.26-.65-2.79-.63s-2.63.83-2.8.63.09-.44.57-.83a3.71,3.71,0,0,1,2.24-.75,3.57,3.57,0,0,1,2.22.75C78.25,245.17,78.41,245.53,78.33,245.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,219.75a7.84,7.84,0,0,0-1.63-.94,5.86,5.86,0,0,0-2.14-.38,5.31,5.31,0,0,0-2.72.79l-.13.08-.08-.13a4.86,4.86,0,0,0-3-2.19,5,5,0,0,0-4.18.66l-.16.11-.11-.15a8,8,0,0,0-5.09-3.09,7.78,7.78,0,0,0-4.64.7,8.1,8.1,0,0,0-3.22,2.86l-.05.08h-.1a12,12,0,0,0-4.8,1.19,12.82,12.82,0,0,0-3.2,2.18,18.36,18.36,0,0,0-2.19,2.64l.1-.21c.07-.13.17-.34.33-.59a11.8,11.8,0,0,1,1.61-2,12.14,12.14,0,0,1,3.22-2.3,11.93,11.93,0,0,1,4.92-1.28l-.15.08a8.31,8.31,0,0,1,3.36-3,8,8,0,0,1,4.87-.74,8.37,8.37,0,0,1,5.34,3.25l-.27,0a5.31,5.31,0,0,1,4.5-.69,5.2,5.2,0,0,1,3.15,2.38l-.21-.05a5.5,5.5,0,0,1,2.88-.77,5.67,5.67,0,0,1,2.21.46,5.28,5.28,0,0,1,1.21.74A2.88,2.88,0,0,1,107.51,219.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.18,217.68a3.58,3.58,0,0,1-1.49.36,5.35,5.35,0,0,1-3.91-1.41,4.84,4.84,0,0,1-1.45-2.57,5.51,5.51,0,0,1,.33-3.39,5,5,0,0,1,2.73-2.62,5.41,5.41,0,0,1,4.09,0l-.23,0a3.83,3.83,0,0,1,2.24-1.27,3.91,3.91,0,0,1,2.17.18,3.57,3.57,0,0,1,1.65,1.34,4,4,0,0,1,.34,3.86l-.27-.24a3.28,3.28,0,0,1,3.07-.06A3.39,3.39,0,0,1,78.26,214a4.31,4.31,0,0,1-1.19,4.28,5.39,5.39,0,0,1-2.62,1.36,5.24,5.24,0,0,1-.79.1c-.18,0-.27,0-.27,0s.37,0,1-.21a5.54,5.54,0,0,0,2.49-1.41,4.06,4.06,0,0,0,1-4,3,3,0,0,0-1.65-1.9,2.91,2.91,0,0,0-2.72.06l-.54.34.27-.58a3.58,3.58,0,0,0-.33-3.48,3.16,3.16,0,0,0-1.46-1.19,3.68,3.68,0,0,0-2-.16,3.44,3.44,0,0,0-2,1.14l-.09.11-.14-.05a5,5,0,0,0-3.79,0,4.72,4.72,0,0,0-2.56,2.4,5.31,5.31,0,0,0-.34,3.19A4.75,4.75,0,0,0,62,216.44a5.3,5.3,0,0,0,3.73,1.45A9,9,0,0,0,67.18,217.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.89,233.15a.82.82,0,0,1-.12-.23,4.19,4.19,0,0,1-.23-.69,6.32,6.32,0,0,1-.06-2.74,6.18,6.18,0,0,1,2.08-3.59,6.62,6.62,0,0,1,5-1.53l-.2.11a7.79,7.79,0,0,1,4-3.78,7.59,7.59,0,0,1,4.18-.49,7.81,7.81,0,0,1,3.53,1.53h-.2a8.56,8.56,0,0,1,4.24-1,9.06,9.06,0,0,1,3.31.67,8,8,0,0,1,1.9,1.1,3.42,3.42,0,0,1,.57.53,11.43,11.43,0,0,0-2.55-1.43,9.08,9.08,0,0,0-3.24-.57,8.37,8.37,0,0,0-4,1l-.11,0-.09-.07a7.54,7.54,0,0,0-3.37-1.43,7.26,7.26,0,0,0-4,.47,7.59,7.59,0,0,0-3.82,3.57l-.06.13-.13,0a6.32,6.32,0,0,0-4.76,1.4,6.13,6.13,0,0,0-2.06,3.39,6.62,6.62,0,0,0,0,2.66C38.79,232.82,38.91,233.14,38.89,233.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.84,343.46l-3.35-5.06-5.38-2.7-.2-.15a7.22,7.22,0,0,0-6.11-1.13c-2.19.58-5.11,1.31-7.65,1.74l-5.78-1.59v11.3l29.2-1.84Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.63,343.15A7.77,7.77,0,0,0,143.4,342c-.79-.66-1.9-1.55-3.13-2.52l-1.16-.9,0,0h0c-1.19-.22-2.23-.4-3-.52a4.94,4.94,0,0,0-1.19-.12,4.43,4.43,0,0,0,1.15.34c.73.18,1.76.4,3,.65l-.08,0,1.15.91c1.24,1,2.37,1.83,3.2,2.44A7.28,7.28,0,0,0,144.63,343.15Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.36,344.14a32.68,32.68,0,0,0-4.2-2.53l-1-.57,0,0h0a21.72,21.72,0,0,0-3.74-.06,23.18,23.18,0,0,0,3.72.41l-.08,0,1,.57A32,32,0,0,0,142.36,344.14Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.83,311.5a2.22,2.22,0,0,0-2.88.62L152.43,344l-37.21.5c-1.49.09-3.29,3.09-2,4.55l42-.58,24.26-33.7A2.23,2.23,0,0,0,178.83,311.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.83,311.5l.18.1a2,2,0,0,1,.47.42,2.26,2.26,0,0,1,.35,2.33,13.39,13.39,0,0,1-1,1.49l-1.24,1.74c-.89,1.26-1.92,2.7-3.07,4.31l-19.1,26.66,0,.07h-.09l-41.26.59h-.85l-.06-.07a2.1,2.1,0,0,1-.51-1.5,3.63,3.63,0,0,1,.4-1.49,4.28,4.28,0,0,1,.9-1.23,2.13,2.13,0,0,1,1.41-.66l5.75-.07,11.1-.15,20.27-.25-.14.07c7.65-10.32,14-18.91,18.5-24.93l5.21-7a2.26,2.26,0,0,1,2.09-.76,1.85,1.85,0,0,1,.74.29,3.09,3.09,0,0,0-.75-.23,2.17,2.17,0,0,0-2,.77l-5.13,7-18.38,25,0,.07h-.09l-20.26.29-11.1.16-5.75.08a1.69,1.69,0,0,0-1.15.55,4,4,0,0,0-.82,1.12,2.31,2.31,0,0,0,.05,2.55l-.14-.07H114l41.26-.54-.14.07,19.21-26.57c1.16-1.6,2.21-3,3.11-4.28l1.26-1.73a13.92,13.92,0,0,0,1-1.46,2.21,2.21,0,0,0-.29-2.25A2.7,2.7,0,0,0,178.83,311.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.32,274.78a26.89,26.89,0,0,0-4.64,3.12A15.67,15.67,0,0,0,54.31,286c-.79,3.85-.16,18.17-.16,22.43s1.08,20.26,1.62,22.92-.35,6.62-1.58,9.2c-2.21,4.62,1.24,7,1.24,7l45.66-.34-.18-1.7c-.31-3,.79-6-.34-8.75s-2.87-9-2-14.29c0,0,5.7-7.08,1-18.5-2.67-6.53-6.9-17.92-15.39-24.46l-10.15-3.31C74.44,276.29,66,274.48,63.32,274.78Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.79,333.26l-39-8.14-1-33.87s-1.37-13.8-8.28-15.08L54.84,296.89c.93,10.45.08,30.22,4.88,37.84S69.19,348.46,81,347.92s37.88-.79,37.88-.79Z",
    style: {
      fill: "#6492FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.85,325.25c.09.07-.84,1.29-1.63,3s-1.13,3.19-1.25,3.17a9.86,9.86,0,0,1,2.88-6.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5,289.8c3.89,12,3,30.43,10.48,37.24l-9.21-1.92a47,47,0,0,0,.08-6.51c-.75-9.46-.84-19.09-1.35-28.81"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M78.63,285.53a21.33,21.33,0,0,1,.69,2.72c.17.9.35,2,.47,3.35s.15,2.87.21,4.59c.22,6.91.54,16.83.93,28.92L80.8,325l39,8.11.16,0v.17c-.29,4.43-.59,9.1-.9,13.86v.18h-.18l-4.75.05c-6.78.08-13.4.19-19.79.32-3.19.07-6.33.15-9.4.26a51.36,51.36,0,0,1-9-.1,19.5,19.5,0,0,1-4.25-1.09,17.81,17.81,0,0,1-3.74-2,25.48,25.48,0,0,1-5.63-5.84q-1.14-1.61-2.16-3.21l-.5-.79c-.16-.27-.3-.55-.45-.83l-.44-.82-.33-.86a33.29,33.29,0,0,1-1.75-6.77,110.14,110.14,0,0,1-1.14-12c-.17-3.52-.25-6.56-.34-9s-.17-4.41-.23-5.71c0-.65-.07-1.14-.1-1.49s0-.51,0-.51,0,.18,0,.51.08.84.14,1.48c.09,1.31.2,3.23.31,5.72s.21,5.52.4,9a110.25,110.25,0,0,0,1.2,11.91,32.67,32.67,0,0,0,1.75,6.7l.33.85.43.8c.15.27.29.55.44.81l.51.79c.68,1.07,1.4,2.12,2.16,3.18a25,25,0,0,0,5.56,5.76,17.81,17.81,0,0,0,3.67,2A19.32,19.32,0,0,0,76,347.5a50.54,50.54,0,0,0,9,.08c3.08-.11,6.22-.19,9.41-.26,6.4-.15,13-.25,19.8-.34l4.74-.05-.19.19c.31-4.76.61-9.43.9-13.87l.16.2-39-8.18-.12,0v-.13c-.33-12.09-.6-22-.79-28.92,0-1.73,0-3.26-.17-4.59a30.38,30.38,0,0,0-.43-3.35c-.16-.9-.31-1.58-.43-2l-.12-.51C78.64,285.59,78.63,285.53,78.63,285.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.25 416.39 135.46 459.07 150.62 461.55 161.39 423.69 141.25 416.39",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.31,350.82s55.38-3.64,66.88-1.81c6.95,1.11,12.94,12,9.16,18.5-1.8,3.09-4.62,12.71-4.62,12.71L137,373.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.96 380.22 124.97 398.51 139.08 407.66 154.39 384.19 136.96 380.22",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.52,347.47s-5.59,25.56,3.6,35.94,22.76,10.38,36.73,8.39S144,389.11,144,389.11s-1.48,9.07-2.57,19.39-1.3,16.86-1.3,16.86l20.77,1.73s11.57-35.23,13.35-42.2,1.18-16.35-5-19.82c-5.21-2.95-46.35-14.36-66-16.05l-2.14-1.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.17,380.62c0,.08-.81.19-2,.63a12.94,12.94,0,0,0-2.08,1,14.61,14.61,0,0,0-2.26,1.64,14.16,14.16,0,0,0-1.87,2.08,12.78,12.78,0,0,0-1.17,2c-.57,1.18-.77,2-.84,2a2,2,0,0,1,.09-.57,8.46,8.46,0,0,1,.49-1.5,12.07,12.07,0,0,1,1.13-2.07,13.81,13.81,0,0,1,1.9-2.16,13.61,13.61,0,0,1,2.35-1.67A11.27,11.27,0,0,1,152,381a8.21,8.21,0,0,1,1.55-.34A2.14,2.14,0,0,1,154.17,380.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.7,359.35a9.55,9.55,0,0,1,2.69-4,30.76,30.76,0,0,1-2.69,4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.13,375.09a1.3,1.3,0,0,1-.06-.2c0-.16-.08-.35-.14-.59-.12-.52-.31-1.29-.62-2.25a17.67,17.67,0,0,0-1.48-3.36,8.39,8.39,0,0,0-3.35-3.37,92.44,92.44,0,0,0-12-4.25c-4.59-1.38-9.66-2.83-15-4.24C131.81,354,122,352,114.84,350.77c-3.58-.61-6.48-1-8.49-1.3l-2.31-.32-.61-.09-.2,0h.21l.61.06,2.32.24c2,.23,4.93.6,8.51,1.17a282.06,282.06,0,0,1,27.72,5.95c5.36,1.42,10.42,2.89,15,4.28a88.4,88.4,0,0,1,12,4.35,8.65,8.65,0,0,1,3.41,3.51,16.6,16.6,0,0,1,1.43,3.43,22.53,22.53,0,0,1,.56,2.27c0,.24.07.44.1.6A.66.66,0,0,1,175.13,375.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.79,460.45l.51-1.85a28.88,28.88,0,0,1-16.73-7.21l-5.13,11.1,34.24,15.22C166,474.44,151.79,460.45,151.79,460.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.44,462.49l1.25-2.71,32.43,15.64s1.22,1.32.56,2.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.34,460.23c-.09.16-1-.14-2,0s-1.82.65-1.95.52.57-1,1.87-1.14S151.44,460.1,151.34,460.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,459a1,1,0,0,1-1.32.46,1,1,0,0,1-.46-1.29,1,1,0,0,1,1.32-.45A.94.94,0,0,1,138,459Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.13,460a2.25,2.25,0,0,1-.78-.14,4.14,4.14,0,0,1-1.92-1,3,3,0,0,1-.45-.59,1.73,1.73,0,0,1-.28-.79.84.84,0,0,1,.53-.85,1.34,1.34,0,0,1,1,.05,3.82,3.82,0,0,1,2.12,3.34l-.51-.07a4,4,0,0,1,.34-.77,4.22,4.22,0,0,1,3.71-2.1,1.44,1.44,0,0,1,.58.11.77.77,0,0,1,.39.51,1.35,1.35,0,0,1-.25,1,3.08,3.08,0,0,1-1.31,1.05,5.13,5.13,0,0,1-2.35.35,2.55,2.55,0,0,1-.86-.07,2.85,2.85,0,0,1,.85-.12,5.84,5.84,0,0,0,2.2-.48,2.79,2.79,0,0,0,1.11-.95,1,1,0,0,0,.16-.67c0-.19-.2-.26-.52-.25a3.76,3.76,0,0,0-3.26,1.88,3.88,3.88,0,0,0-.29.67.26.26,0,0,1-.33.16.24.24,0,0,1-.18-.23,3.44,3.44,0,0,0-1.79-2.94c-.47-.25-1,0-1,.37a2.36,2.36,0,0,0,.58,1.17,4.43,4.43,0,0,0,1.73,1.07A3.32,3.32,0,0,1,151.13,460Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,462.61a11.49,11.49,0,0,0-2.26.16,11.91,11.91,0,0,0-2.08.92,3.55,3.55,0,0,1,4.34-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.87,464.78c0,.12-.94.09-2,.41s-1.84.84-1.91.75a3,3,0,0,1,1.79-1.13A3,3,0,0,1,155.87,464.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.77,405.6l.81-1.74a28.83,28.83,0,0,1-15.28-9.92L120.38,404l31.18,20.78C153.39,421.78,141.77,405.6,141.77,405.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.38,404l1.69-2.46,29.33,20.88s1,1.51.16,2.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.35,405.31c-.1.14-.91-.3-2-.32s-1.91.33-2,.18.72-.86,2-.8S141.48,405.2,141.35,405.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.42,401.89a1,1,0,0,1-1.38.23,1,1,0,0,1-.24-1.35,1,1,0,0,1,1.38-.22A1,1,0,0,1,128.42,401.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.19,405.05a2.18,2.18,0,0,1-.74-.27,4.11,4.11,0,0,1-1.72-1.33,3,3,0,0,1-.35-.66,1.81,1.81,0,0,1-.15-.83.85.85,0,0,1,.67-.74,1.3,1.3,0,0,1,1,.22,3.81,3.81,0,0,1,1.52,3.65l-.48-.16a4.67,4.67,0,0,1,.46-.7,4.22,4.22,0,0,1,4-1.44,1.3,1.3,0,0,1,.55.21.71.71,0,0,1,.3.56,1.37,1.37,0,0,1-.41.94,3,3,0,0,1-1.47.81,5.19,5.19,0,0,1-2.38-.05,3.28,3.28,0,0,1-.83-.21,2.48,2.48,0,0,1,.86,0,5.67,5.67,0,0,0,2.24-.1,2.76,2.76,0,0,0,1.26-.76.87.87,0,0,0,.27-.63c0-.19-.16-.28-.47-.33a3.74,3.74,0,0,0-3.52,1.3,3.62,3.62,0,0,0-.41.61.25.25,0,0,1-.35.11.26.26,0,0,1-.14-.26,3.42,3.42,0,0,0-1.27-3.2c-.42-.32-1-.2-1,.21a2.28,2.28,0,0,0,.37,1.24,4.34,4.34,0,0,0,1.52,1.35A2.86,2.86,0,0,1,141.19,405.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.54,408.09a12.51,12.51,0,0,0-2.26-.22,12.49,12.49,0,0,0-2.2.56,2.88,2.88,0,0,1,2.17-1A2.92,2.92,0,0,1,143.54,408.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.06,410.56c0,.11-.94-.07-2.05.07s-1.95.51-2,.41a3,3,0,0,1,2-.81A2.93,2.93,0,0,1,145.06,410.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.27,258.16a2.44,2.44,0,0,0-2.21-.81,2.24,2.24,0,0,0-1.49.88,1.4,1.4,0,0,0,0,1.61,1.61,1.61,0,0,0,1.78.37A5.18,5.18,0,0,0,81,259.12a1.49,1.49,0,0,0,.37-.42.45.45,0,0,0,0-.49",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.79,256c.21,0,.28,1.44,1.57,2.42s2.83.76,2.85,1-.33.29-1,.34a3.64,3.64,0,0,1-2.38-.72,3.19,3.19,0,0,1-1.22-2C77.54,256.36,77.69,256,77.79,256Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshop);
export default __webpack_public_path__ + "static/media/workshop.f60872efd876efea3f5ee93570d8c820.svg";
export { ForwardRef as ReactComponent };